package com.schoolconnect.app.feature.home

import androidx.compose.foundation.ScrollState
import androidx.compose.foundation.background
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.clickable
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.animateContentSize
import androidx.compose.animation.expandVertically
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.shrinkVertically
import androidx.compose.animation.slideInHorizontally
import androidx.compose.animation.slideOutHorizontally
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.animation.core.FastOutSlowInEasing
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Info
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.mutableStateOf
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.Dp
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.ic_launcher
import org.jetbrains.compose.resources.painterResource
import com.schoolconnect.app.domain.SchoolKeys
import com.schoolconnect.app.designsystem.AdminSummaryMetrics
import com.schoolconnect.app.designsystem.AppBrandWordmark
import com.schoolconnect.app.designsystem.AppBrandWordmarkDark
import com.schoolconnect.app.designsystem.AppBrandWordmarkLight
import com.schoolconnect.app.designsystem.AppButton
import com.schoolconnect.app.designsystem.AppPageHeader
import com.schoolconnect.app.designsystem.AppPageSubtitle
import com.schoolconnect.app.designsystem.AppDropdownMenu
import com.schoolconnect.app.designsystem.list.AdminListEmptyState
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.LocalParentChildContext
import com.schoolconnect.app.feature.common.LocalProfileAction
import com.schoolconnect.app.feature.common.ParentChildContext
import com.schoolconnect.app.feature.common.ParentChildHeaderSelector
import com.schoolconnect.app.feature.common.AppScreenTransition
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.feature.common.FeatureEntry
import com.schoolconnect.app.feature.common.compareSmartText
import com.schoolconnect.app.feature.academicyears.AcademicYearsFeatureRoute
import com.schoolconnect.app.feature.reports.ReportsFeatureRoute
import com.schoolconnect.app.feature.reports.ParentStudentPerformanceReport
import com.schoolconnect.app.feature.reports.StaffPerformanceReportsScreen
import com.schoolconnect.app.feature.schoolconfig.SchoolConfigFeatureRoute
import com.schoolconnect.app.feature.itusers.ITUsersFeatureRoute
import com.schoolconnect.app.feature.schools.SchoolsFeatureRoute
import com.schoolconnect.app.feature.schoolusers.SchoolUsersFeatureRoute
import com.schoolconnect.app.feature.mystudents.TeacherMyStudentsScreen
import com.schoolconnect.app.feature.mystudents.TeacherMyStudentsViewModel
import com.schoolconnect.app.feature.attendance.AttendanceScreen
import com.schoolconnect.app.feature.attendance.AttendanceViewModel
import com.schoolconnect.app.feature.attendance.ParentAttendanceScreen
import com.schoolconnect.app.feature.attendance.ParentAttendanceViewModel
import com.schoolconnect.app.feature.homework.HomeworkScreen
import com.schoolconnect.app.feature.homework.HomeworkViewModel
import com.schoolconnect.app.feature.homework.ParentHomeworkScreen
import com.schoolconnect.app.feature.homework.ParentHomeworkViewModel
import com.schoolconnect.app.feature.notices.NoticesScreen
import com.schoolconnect.app.feature.notices.ParentNoticesScreen
import com.schoolconnect.app.feature.notices.ParentNoticesViewModel
import com.schoolconnect.app.feature.notices.NoticesViewModel
import com.schoolconnect.app.feature.quickannouncements.QuickAnnouncementsScreen
import com.schoolconnect.app.feature.quickannouncements.QuickAnnouncementsViewModel
import com.schoolconnect.app.feature.eventsnews.EventsNewsScreen
import com.schoolconnect.app.feature.eventsnews.EventsNewsViewModel
import com.schoolconnect.app.feature.eventsnews.ParentEventsNewsScreen
import com.schoolconnect.app.feature.eventsnews.ParentEventsNewsViewModel
import com.schoolconnect.app.feature.parentnotes.ParentNotesScreen
import com.schoolconnect.app.feature.parentnotes.ParentNotesViewModel
import com.schoolconnect.app.feature.parentnotes.ParentPortalNotesScreen
import com.schoolconnect.app.feature.parentnotes.ParentPortalNotesViewModel
import com.schoolconnect.app.feature.classconversations.ClassConversationsScreen
import com.schoolconnect.app.feature.classconversations.AdminClassConversationsApiScreen
import com.schoolconnect.app.feature.classconversations.ClassConversationsUiState
import com.schoolconnect.app.feature.classconversations.ClassConversationsViewModel
import com.schoolconnect.app.feature.common.ParentChildSelectionStore
import com.schoolconnect.app.feature.exams.ExamsScreen
import com.schoolconnect.app.feature.examresults.ExamResultsScreen
import com.schoolconnect.app.feature.examresults.ExamResultsViewModel
import com.schoolconnect.app.feature.examresults.ParentExamResultsScreen
import com.schoolconnect.app.feature.examresults.ParentExamResultsViewModel
import com.schoolconnect.app.feature.exams.ExamsViewModel
import com.schoolconnect.app.feature.calendar.CalendarScreen
import com.schoolconnect.app.feature.calendar.CalendarViewModel
import com.schoolconnect.app.feature.timetable.ParentTimeTableScreen
import com.schoolconnect.app.feature.timetable.ParentTimeTableViewModel
import com.schoolconnect.app.feature.timetable.TeacherTimeTableScreen
import com.schoolconnect.app.feature.documents.ParentDocumentLibraryScreen
import com.schoolconnect.app.feature.documents.ParentDocumentLibraryViewModel
import com.schoolconnect.app.feature.documents.DocumentLibraryScreen
import com.schoolconnect.app.feature.documents.DocumentLibraryViewModel
import com.schoolconnect.app.feature.support.SupportCenterScreen
import com.schoolconnect.app.feature.support.SuperAdminSupportQueueScreen
import com.schoolconnect.app.feature.rolepicker.RolePickerDialog
import com.schoolconnect.app.designsystem.list.AdminListPanelHeader
import com.schoolconnect.app.designsystem.list.DesktopAwareLazyColumn
import com.schoolconnect.app.datasource.NavigationStateStore
import com.schoolconnect.app.theme.interSemiBold
import com.schoolconnect.app.datasource.network.response.TeacherDashboardOverviewResponse
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

@Composable
fun HomeScreen(
    state: HomeUiState,
    features: List<FeatureEntry>,
    onEvent: (HomeUiEvent) -> Unit,
    onOpenFeature: (String) -> Unit,
    onToggleTheme: () -> Unit,
    onLogout: () -> Unit
) {
    if (state.roleCode == SchoolKeys.V_ROLE_SCHOOL_ADMIN) {
        var showEditProfile by remember { mutableStateOf(false) }
        SchoolAdminHomeScreen(
            state = state,
            features = features,
            onEvent = onEvent,
            onOpenFeature = onOpenFeature,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onEditProfile = { showEditProfile = true }
        )
        EditProfileModal(
            open = showEditProfile,
            initialValues = state.userProfile.toEditProfileFormValues(),
            roleCode = state.roleCode,
            onClose = { showEditProfile = false },
            onSave = { values ->
                onEvent(HomeUiEvent.ProfileSaved(values))
                showEditProfile = false
            }
        )
        return
    }

    val content = remember(
        state.selectedNavId,
        state.dashboardAnalytics,
        state.dashboardSchoolsAnalytics,
        state.dashboardStatistics,
        state.recentActivities,
        state.systemHealth,
        state.roleCode
    ) {
        HomeDefaults.dashboardContent(
            selectedNavId = state.selectedNavId,
            roleCode = state.roleCode,
            analytics = state.dashboardAnalytics,
            schoolsAnalytics = state.dashboardSchoolsAnalytics,
            statistics = state.dashboardStatistics,
            recentActivities = state.recentActivities,
            systemHealth = state.systemHealth
        )
    }
    var showEditProfile by remember { mutableStateOf(false) }
    var selectedParentChildId by remember(state.schoolId) { mutableStateOf("") }
    val availableParentChildren = remember(state.parentProfile?.students, state.parentDashboard?.children, state.parentWards) {
        parentLinkedChildren(state)
    }
    LaunchedEffect(availableParentChildren, selectedParentChildId) {
        ParentChildSelectionStore.setChildren(availableParentChildren)
        val selectedStillExists = availableParentChildren.any { it.id == selectedParentChildId }
        if (availableParentChildren.isNotEmpty() && !selectedStillExists) {
            selectedParentChildId = availableParentChildren.first().id
            ParentChildSelectionStore.select(availableParentChildren.first().id)
        }
    }
    val parentChildContext = ParentChildContext(
        children = if (state.roleCode == SchoolKeys.V_ROLE_PARENT) availableParentChildren else emptyList(),
        selectedChildId = selectedParentChildId,
        onSelected = { childId ->
            selectedParentChildId = childId
            ParentChildSelectionStore.select(childId)
        }
    )

    CompositionLocalProvider(
        LocalParentChildContext provides parentChildContext,
        LocalProfileAction provides { showEditProfile = true }
    ) {
        BoxWithConstraints(
            modifier = Modifier
                .fillMaxSize()
                .background(HomeBg)
        ) {
        // Use the actual orientation together with a minimum width. A
        // CSS pixels are converted to Compose dp, so use a density-safe
        // landscape minimum before switching to the desktop shell and rail.
        val landscape = maxWidth > maxHeight
        val compact = !landscape || maxWidth < 500.dp
        if (compact) {
            CompactHomeLayout(
                state = state,
                content = content,
                features = features,
                onEvent = onEvent,
                onOpenFeature = onOpenFeature,
                onToggleTheme = onToggleTheme,
                onLogout = onLogout,
                onEditProfile = { showEditProfile = true }
            )
        } else {
            DesktopHomeLayout(
                state = state,
                content = content,
                features = features,
                onEvent = onEvent,
                onOpenFeature = onOpenFeature,
                onToggleTheme = onToggleTheme,
                onLogout = onLogout,
                maxWidth = maxWidth,
                onEditProfile = { showEditProfile = true }
            )
        }

            if (state.rolePicker.isVisible) {
            RolePickerDialog(
                state = state.rolePicker,
                onOptionSelected = { onEvent(HomeUiEvent.RolePickerSelectionChanged(it.id)) },
                onRememberSelectionChanged = { onEvent(HomeUiEvent.RolePickerRememberChanged(it)) },
                onContinueClicked = { onEvent(HomeUiEvent.RolePickerContinueClicked) },
                onCloseClicked = { onEvent(HomeUiEvent.RolePickerClosed) }
            )
        }

            EditProfileModal(
            open = showEditProfile,
            initialValues = state.userProfile.toEditProfileFormValues(),
            roleCode = state.roleCode,
            onClose = { showEditProfile = false },
            onSave = { values ->
                onEvent(HomeUiEvent.ProfileSaved(values))
                showEditProfile = false
            }
            )
        }
    }
}

@Composable
private fun DesktopHomeLayout(
    state: HomeUiState,
    content: HomeDashboardContent,
    features: List<FeatureEntry>,
    onEvent: (HomeUiEvent) -> Unit,
    onOpenFeature: (String) -> Unit,
    onToggleTheme: () -> Unit,
    onLogout: () -> Unit,
    maxWidth: androidx.compose.ui.unit.Dp,
    onEditProfile: () -> Unit
) {
    val railWidth by animateDpAsState(
        targetValue = when {
            state.isSidebarCollapsed -> 72.dp
            else -> 280.dp
        },
        animationSpec = tween(300, easing = FastOutSlowInEasing),
        label = "home_rail_width"
    )
    Row(modifier = Modifier.fillMaxSize()) {
        SidebarPanel(
            content = content,
            state = state,
            onEvent = onEvent,
            onOpenFeature = onOpenFeature,
            features = features,
            onLogout = onLogout,
            modifier = Modifier
                .width(railWidth)
                .fillMaxSize()
        )
        MainHomeContent(
            state = state,
            content = content,
            onEvent = onEvent,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onEditProfile = onEditProfile,
            modifier = Modifier.weight(1f),
            contentWidth = if (maxWidth > 1480.dp) 1280.dp else 1180.dp,
            metricColumns = 4
        )
    }
}

private fun railLabelEnter() =
    fadeIn(animationSpec = tween(160, delayMillis = 35, easing = LinearEasing)) +
        slideInHorizontally(
            animationSpec = tween(220, easing = FastOutSlowInEasing),
            initialOffsetX = { -it / 4 }
        )

private fun railLabelExit() =
    fadeOut(animationSpec = tween(110, easing = LinearEasing)) +
        slideOutHorizontally(
            animationSpec = tween(170, easing = FastOutSlowInEasing),
            targetOffsetX = { -it / 5 }
        )

private fun railChildrenEnter() =
    fadeIn(animationSpec = tween(150, easing = LinearEasing)) +
        expandVertically(
            expandFrom = Alignment.Top,
            animationSpec = tween(220, easing = FastOutSlowInEasing)
        )

private fun railChildrenExit() =
    fadeOut(animationSpec = tween(100, easing = LinearEasing)) +
        shrinkVertically(
            shrinkTowards = Alignment.Top,
            animationSpec = tween(180, easing = FastOutSlowInEasing)
        )

@Composable
private fun CompactHomeLayout(
    state: HomeUiState,
    content: HomeDashboardContent,
    features: List<FeatureEntry>,
    onEvent: (HomeUiEvent) -> Unit,
    onOpenFeature: (String) -> Unit,
    onToggleTheme: () -> Unit,
    onLogout: () -> Unit,
    onEditProfile: () -> Unit
) {
    Column(modifier = Modifier.fillMaxSize()) {
        CompactTopBar(
            state = state,
            onEvent = onEvent,
            onLogout = onLogout,
            onEditProfile = onEditProfile
        )
        MainHomeContent(
            state = state,
            content = content,
            onEvent = onEvent,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onEditProfile = onEditProfile,
            modifier = Modifier.weight(1f),
            contentWidth = 1120.dp,
            metricColumns = 2
        )
    }
}

@Composable
private fun SidebarPanel(
    content: HomeDashboardContent,
    state: HomeUiState,
    onEvent: (HomeUiEvent) -> Unit,
    onOpenFeature: (String) -> Unit,
    features: List<FeatureEntry>,
    onLogout: () -> Unit,
    modifier: Modifier = Modifier
) {
    if (state.roleCode == SchoolKeys.V_ROLE_APP_SUPER_ADMIN) {
        SuperAdminSidebarPanel(
            content = content,
            state = state,
            onEvent = onEvent,
            modifier = modifier
        )
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_TEACHER || state.roleCode == SchoolKeys.V_ROLE_PARENT) {
        TeacherSidebarPanel(
            content = content,
            state = state,
            onEvent = onEvent,
            onOpenFeature = onOpenFeature,
            modifier = modifier
        )
        return
    }

    val visibleFeatures = features.associateBy { it.id }
    val isCollapsed = state.isSidebarCollapsed
    var expandedTeacherItem by remember(state.roleCode) {
        mutableStateOf("exams")
    }
    val dashboardItem = content.navGroups
        .asSequence()
        .flatMap { it.items.asSequence() }
        .firstOrNull { it.id == "dashboard" }
        ?: if (state.roleCode == SchoolKeys.V_ROLE_TEACHER || state.roleCode == SchoolKeys.V_ROLE_PARENT) {
            NavItem(
                id = "dashboard",
                title = "Dashboard",
                icon = "dashboard",
                isActive = state.selectedNavId == "dashboard"
            )
        } else {
            null
        }
    Column(
        modifier = modifier
            .background(Color.White)
            .border(BorderStroke(1.dp, HomeBorder))
            .padding(horizontal = if (isCollapsed) 8.dp else 16.dp, vertical = 12.dp)
    ) {
        if (state.roleCode == SchoolKeys.V_ROLE_TEACHER || state.roleCode == SchoolKeys.V_ROLE_PARENT) {
            TeacherRailBrand(
                schoolName = state.schoolLabel,
                academicYearLabel = state.activeAcademicYearLabel.ifBlank { if (state.roleCode == SchoolKeys.V_ROLE_PARENT) "AY 2026-27" else "" },
                compact = isCollapsed
            )
        } else {
            SidebarBrand(compact = isCollapsed)
        }

        Spacer(modifier = Modifier.height(if (isCollapsed) 8.dp else 12.dp))

        dashboardItem?.let { item ->
            SidebarNavItem(
                item = item.copy(
                    isClickable = visibleFeatures.containsKey(item.id) || item.id == "dashboard"
                ),
                compact = isCollapsed,
                onClick = { onEvent(HomeUiEvent.NavSelected(item.id)) }
            )
        }

        Spacer(modifier = Modifier.height(if (isCollapsed) 10.dp else 14.dp))

        DesktopAwareLazyColumn(
            modifier = Modifier
                .weight(1f),
            scrollbarEndOffset = if (isCollapsed) 10.dp else 14.dp,
            verticalArrangement = Arrangement.spacedBy(if (isCollapsed) 8.dp else 12.dp)
        ) {
            content.navGroups.forEach { group ->
                val items = group.items.filterNot { it.id == "dashboard" }
                if (items.isEmpty()) return@forEach
                if (!isCollapsed && group.label.isNotBlank()) {
                    item(key = "sidebar-group-header-${group.label}") {
                        Text(
                            text = group.label,
                            color = HomeTextSecondary,
                            style = MaterialTheme.typography.labelSmall,
                            fontWeight = FontWeight.SemiBold
                        )
                    }
                }
                items.forEach { item ->
                    item(key = "sidebar-item-${group.label}-${item.id}") {
                        val isKnownFeature = visibleFeatures.containsKey(item.id) && item.id != "config"
                        if (state.roleCode == SchoolKeys.V_ROLE_TEACHER && item.children.isNotEmpty()) {
                            TeacherExpandableRailItem(
                                item = item,
                                compact = isCollapsed,
                                expanded = item.id == expandedTeacherItem,
                                onToggleExpanded = {
                                    expandedTeacherItem = if (item.id == expandedTeacherItem) "" else item.id
                                },
                                onItemClick = { child ->
                                    onEvent(HomeUiEvent.NavSelected(child.id))
                                }
                            )
                        } else {
                            SidebarNavItem(
                                item = item.copy(isClickable = isKnownFeature || item.id == "help-desk" || item.id == "dashboard" || (state.roleCode == SchoolKeys.V_ROLE_PARENT && item.id == "exam-results")),
                                compact = isCollapsed,
                                onClick = {
                                    onEvent(HomeUiEvent.NavSelected(item.id))
                                    if (state.roleCode == SchoolKeys.V_ROLE_TEACHER && item.id == "students") {
                                        onOpenFeature("students")
                                    } else if (item.id == "config" && isKnownFeature) {
                                        onOpenFeature("config")
                                    }
                                }
                            )
                        }
                    }
                }
                if (group.label.isNotBlank()) {
                    item(key = "sidebar-group-divider-${group.label}") {
                        androidx.compose.material3.HorizontalDivider(color = HomeBorder)
                    }
                }
            }
        }

        if (state.roleCode == SchoolKeys.V_ROLE_TEACHER) {
            TeacherRailFooter(
                compact = isCollapsed,
                onToggleCollapse = { onEvent(HomeUiEvent.SidebarCollapseToggled) }
            )
        } else {
            HomeSidebarFooter(
                compact = isCollapsed,
                onToggleCollapse = { onEvent(HomeUiEvent.SidebarCollapseToggled) }
            )
        }
    }
}

@Composable
internal fun TeacherSidebarPanel(
    content: HomeDashboardContent,
    state: HomeUiState,
    onEvent: (HomeUiEvent) -> Unit,
    onOpenFeature: (String) -> Unit,
    administrationGroups: List<NavGroup> = emptyList(),
    modifier: Modifier = Modifier
) {
    val storedExpandedGroup = remember(state.roleCode, state.schoolId) {
        NavigationStateStore.getExpandedRailGroup(state.roleCode, state.schoolId)
    }
    val contentItems = content.navGroups.flatMap { it.items }.flatMap { groupItem ->
        listOf(groupItem) + groupItem.children
    }

    fun item(id: String, title: String, icon: String): NavItem {
        return contentItems.firstOrNull { it.id == id }?.copy(title = title, icon = icon)
            ?: NavItem(id = id, title = title, icon = icon, isActive = state.selectedNavId == id)
    }

    val dashboard = item("dashboard", "Dashboard", "dashboard")
    val academics = contentItems.firstOrNull { it.id == "academics" }
        ?: NavItem("academics", "Academics", "book")
    val communication = contentItems.firstOrNull { it.id == "communication" }
        ?: NavItem("communication", "Communication", "message")
    val standaloneItems = listOf(
        item("calendar", "Calendar", "calendar"),
        item("analytics-reports", "Reports & Analytics", "reports")
    )
    val helpItem = item("help-desk", "Help & Support", "help_desk")
    val helpNavId = if (state.roleCode == SchoolKeys.V_ROLE_SCHOOL_ADMIN) "support-center" else helpItem.id
    val administrationGroupForSelectedNav = administrationGroups.firstOrNull { group ->
        group.items.any { it.id == state.selectedNavId }
    }?.let { "administration:${it.label}" }
    val selectedGroup = when {
        academics.id == state.selectedNavId || academics.children.any { it.id == state.selectedNavId } -> "academics"
        communication.id == state.selectedNavId || communication.children.any { it.id == state.selectedNavId } -> "communication"
        administrationGroupForSelectedNav != null -> administrationGroupForSelectedNav
        else -> ""
    }
    var expandedGroupKey by remember(state.roleCode, state.schoolId) {
        mutableStateOf(selectedGroup.ifBlank { storedExpandedGroup.ifBlank { "academics" } })
    }
    val railListState = rememberLazyListState()

    fun setExpandedGroup(groupKey: String) {
        expandedGroupKey = if (expandedGroupKey == groupKey) "" else groupKey
        NavigationStateStore.setExpandedRailGroup(
            roleCode = state.roleCode,
            schoolId = state.schoolId,
            groupKey = expandedGroupKey
        )
    }

    fun openRailItem(navItem: NavItem) {
        onEvent(HomeUiEvent.NavSelected(navItem.id))
        if (navItem.id == "students" && state.roleCode == SchoolKeys.V_ROLE_TEACHER) {
            onOpenFeature("students")
        }
    }

    Column(
        modifier = modifier
            .background(Color.White)
            .border(BorderStroke(1.dp, HomeBorder))
            .padding(horizontal = if (state.isSidebarCollapsed) 8.dp else 16.dp, vertical = 12.dp)
    ) {
        TeacherRailBrand(
            schoolName = state.schoolLabel,
            academicYearLabel = "",
            compact = state.isSidebarCollapsed
        )
        Spacer(modifier = Modifier.height(if (state.isSidebarCollapsed) 8.dp else 18.dp))

        SuperAdminStandaloneRailItem(
            item = dashboard.copy(isClickable = true),
            compact = state.isSidebarCollapsed,
            onClick = { onEvent(HomeUiEvent.NavSelected("dashboard")) }
        )

        Spacer(modifier = Modifier.height(if (state.isSidebarCollapsed) 10.dp else 16.dp))

        DesktopAwareLazyColumn(
            modifier = Modifier.weight(1f),
            state = railListState,
            scrollbarEndOffset = if (state.isSidebarCollapsed) 10.dp else 14.dp,
            verticalArrangement = Arrangement.spacedBy(if (state.isSidebarCollapsed) 10.dp else 12.dp)
        ) {
            item(key = "teacher-academics") {
                TeacherExpandableRailItem(
                    item = academics,
                    compact = state.isSidebarCollapsed,
                    expanded = expandedGroupKey == "academics",
                    onToggleExpanded = {
                        setExpandedGroup("academics")
                    },
                    onItemClick = ::openRailItem
                )
            }
            item(key = "teacher-academics-divider") { HorizontalDivider(color = HomeBorder) }
            item(key = "teacher-communication") {
                TeacherExpandableRailItem(
                    item = communication,
                    compact = state.isSidebarCollapsed,
                    expanded = expandedGroupKey == "communication",
                    onToggleExpanded = {
                        setExpandedGroup("communication")
                    },
                    onItemClick = ::openRailItem
                )
            }
            item(key = "teacher-communication-divider") { HorizontalDivider(color = HomeBorder) }
            standaloneItems.forEach { navItem ->
                item(key = "teacher-standalone-${navItem.id}") {
                    SuperAdminStandaloneRailItem(
                        item = navItem.copy(isClickable = true),
                        compact = state.isSidebarCollapsed,
                        onClick = { onEvent(HomeUiEvent.NavSelected(navItem.id)) }
                    )
                }
            }
            if (administrationGroups.isNotEmpty()) {
                item(key = "teacher-administration-divider") { HorizontalDivider(color = HomeBorder) }
                item(key = "teacher-administration-label") {
                    Text(
                        text = "ADMINISTRATION",
                        style = MaterialTheme.typography.labelSmall,
                        fontWeight = FontWeight.SemiBold,
                        color = HomeTextMuted,
                        modifier = Modifier.padding(horizontal = 6.dp, vertical = 2.dp)
                    )
                }
                administrationGroups.forEach { group ->
                    val groupKey = "administration:${group.label}"
                    val expanded = expandedGroupKey == groupKey
                    item(key = "teacher-administration-${group.label}") {
                        TeacherExpandableRailItem(
                            item = NavItem(
                                id = group.label,
                                title = group.label,
                                icon = when (group.label) {
                                    "Bulk Import" -> "database_download"
                                    "Manage Records" -> "folder"
                                    else -> group.items.firstOrNull()?.icon ?: "folder"
                                },
                                children = group.items
                            ),
                            compact = state.isSidebarCollapsed,
                            expanded = expanded,
                            onToggleExpanded = {
                                setExpandedGroup(groupKey)
                            },
                            onItemClick = ::openRailItem
                        )
                    }
                }
            }
            item(key = "teacher-help-divider") { HorizontalDivider(color = HomeBorder) }
            item(key = "teacher-help") {
                SuperAdminStandaloneRailItem(
                    item = helpItem.copy(isClickable = true),
                    compact = state.isSidebarCollapsed,
                    onClick = { onEvent(HomeUiEvent.NavSelected(helpNavId)) }
                )
            }
        }

        TeacherReferenceRailFooter(
            compact = state.isSidebarCollapsed,
            onToggleCollapse = { onEvent(HomeUiEvent.SidebarCollapseToggled) }
        )
    }
}

@Composable
private fun SuperAdminSidebarPanel(
    content: HomeDashboardContent,
    state: HomeUiState,
    onEvent: (HomeUiEvent) -> Unit,
    modifier: Modifier = Modifier
) {
    val schoolManagementIds = remember {
        setOf("schools", "academic-years", "school-users", "school-config")
    }
    val platformOperationsIds = remember {
        setOf("it-users", "help-desk")
    }
    val storedExpandedGroup = remember(state.roleCode, state.schoolId) {
        NavigationStateStore.getExpandedRailGroup(state.roleCode, state.schoolId)
    }
    val selectedGroup = when {
        state.selectedNavId in schoolManagementIds -> "school-management"
        state.selectedNavId in platformOperationsIds -> "platform-operations"
        else -> ""
    }
    var expandedGroupKey by remember(state.roleCode, state.schoolId) {
        mutableStateOf(selectedGroup.ifBlank { storedExpandedGroup.ifBlank { "school-management" } })
    }
    val railListState = rememberLazyListState()
    val contentItems = content.navGroups.flatMap { it.items }

    fun item(id: String, title: String, icon: String): NavItem {
        return contentItems.firstOrNull { it.id == id }?.copy(title = title, icon = icon)
            ?: NavItem(id = id, title = title, icon = icon, isActive = state.selectedNavId == id)
    }

    val dashboard = item("dashboard", "Dashboard", "dashboard")
    val schoolManagement = listOf(
        item("schools", "Schools", "schools"),
        item("academic-years", "Academic Years", "academic_years"),
        item("school-users", "School Administrators", "school_users"),
        item("school-config", "Configuration", "config")
    )
    val platformOperations = listOf(
        item("it-users", "IT Support Users", "it_users"),
        item("help-desk", "Support Center", "help_desk")
    )
    val reports = item("reports", "Reports & Analytics", "reports")

    fun setExpandedGroup(groupKey: String) {
        expandedGroupKey = if (expandedGroupKey == groupKey) "" else groupKey
        NavigationStateStore.setExpandedRailGroup(
            roleCode = state.roleCode,
            schoolId = state.schoolId,
            groupKey = expandedGroupKey
        )
    }

    LaunchedEffect(state.selectedNavId, expandedGroupKey) {
        val targetIndex = when {
            state.selectedNavId in schoolManagementIds -> 0
            state.selectedNavId in platformOperationsIds -> 2
            state.selectedNavId == reports.id -> 4
            else -> null
        }
        if (targetIndex != null) {
            railListState.animateScrollToItem(targetIndex)
        }
    }

    Column(
        modifier = modifier
            .background(Color.White)
            .padding(horizontal = 14.dp, vertical = 12.dp)
    ) {
        SuperAdminRailBrand(compact = state.isSidebarCollapsed)
        Spacer(modifier = Modifier.height(if (state.isSidebarCollapsed) 8.dp else 18.dp))

        SuperAdminStandaloneRailItem(
            item = dashboard.copy(isClickable = true),
            compact = state.isSidebarCollapsed,
            onClick = { onEvent(HomeUiEvent.NavSelected("dashboard")) }
        )

        Spacer(modifier = Modifier.height(if (state.isSidebarCollapsed) 10.dp else 16.dp))

        DesktopAwareLazyColumn(
            modifier = Modifier.weight(1f),
            state = railListState,
            scrollbarEndOffset = if (state.isSidebarCollapsed) 10.dp else 14.dp,
            verticalArrangement = Arrangement.spacedBy(if (state.isSidebarCollapsed) 10.dp else 12.dp)
        ) {
            item(key = "super-admin-school-management") {
                SuperAdminExpandableRailItem(
                    title = "School Setup",
                    icon = "building",
                    children = schoolManagement,
                    expanded = expandedGroupKey == "school-management",
                    compact = state.isSidebarCollapsed,
                    onToggleExpanded = {
                        setExpandedGroup("school-management")
                    },
                    onItemClick = { navItem -> onEvent(HomeUiEvent.NavSelected(navItem.id)) }
                )
            }
            item(key = "super-admin-school-management-divider") {
                HorizontalDivider(color = HomeBorder)
            }
            item(key = "super-admin-platform-operations") {
                SuperAdminExpandableRailItem(
                    title = "Platform Operations",
                    icon = "folder",
                    children = platformOperations,
                    expanded = expandedGroupKey == "platform-operations",
                    compact = state.isSidebarCollapsed,
                    onToggleExpanded = {
                        setExpandedGroup("platform-operations")
                    },
                    onItemClick = { navItem -> onEvent(HomeUiEvent.NavSelected(navItem.id)) }
                )
            }
            item(key = "super-admin-platform-operations-divider") {
                HorizontalDivider(color = HomeBorder)
            }
            item(key = "super-admin-reports") {
                SuperAdminStandaloneRailItem(
                    item = reports.copy(isClickable = true),
                    compact = state.isSidebarCollapsed,
                    onClick = { onEvent(HomeUiEvent.NavSelected(reports.id)) }
                )
            }
        }

        SuperAdminRailFooter(
            compact = state.isSidebarCollapsed,
            onToggleCollapse = { onEvent(HomeUiEvent.SidebarCollapseToggled) }
        )
    }
}

@Composable
private fun SuperAdminStandaloneRailItem(
    item: NavItem,
    compact: Boolean,
    onClick: () -> Unit
) {
    val contentColor = if (item.isActive) HomeRailSelected else HomeTextPrimary
    RailTooltip(label = item.title, enabled = compact) {
        Row(
                modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(12.dp))
                .background(if (item.isActive) HomeRailSelectedSoft else Color.Transparent)
                .clickable(onClick = onClick)
                .padding(horizontal = if (compact) 0.dp else 6.dp, vertical = if (compact) 10.dp else 12.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = if (compact) Arrangement.Center else Arrangement.spacedBy(14.dp)
        ) {
            Icon(
                painter = homeIconPainter(item.icon),
                contentDescription = null,
                tint = contentColor,
                modifier = Modifier.size(if (compact) 22.dp else 20.dp)
            )
            AnimatedVisibility(
                visible = !compact,
                enter = railLabelEnter(),
                exit = railLabelExit()
            ) {
                Text(
                    text = item.title,
                    style = MaterialTheme.typography.bodyLarge,
                    fontWeight = if (item.isActive) FontWeight.Bold else FontWeight.Normal,
                    color = contentColor,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
        }
    }
}

@Composable
private fun SuperAdminRailBrand(compact: Boolean) {
    if (compact) {
        androidx.compose.foundation.Image(
            painter = painterResource(Res.drawable.ic_launcher),
            contentDescription = "iConnect.School",
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 10.dp, vertical = 6.dp)
                .size(54.dp),
            contentScale = androidx.compose.ui.layout.ContentScale.Fit
        )
    } else {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 10.dp, vertical = 4.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(10.dp)
        ) {
            androidx.compose.foundation.Image(
                painter = painterResource(Res.drawable.ic_launcher),
                contentDescription = "iConnect.School",
                modifier = Modifier.size(48.dp),
                contentScale = androidx.compose.ui.layout.ContentScale.Fit
            )
            AppBrandWordmark(
                style = MaterialTheme.typography.titleLarge,
                fontWeight = FontWeight.Bold
            )
        }
    }
}

@Composable
private fun SuperAdminExpandableRailItem(
    title: String,
    icon: String,
    children: List<NavItem>,
    expanded: Boolean,
    compact: Boolean,
    onToggleExpanded: () -> Unit,
    onItemClick: (NavItem) -> Unit
) {
    val isActive = children.any { it.isActive }
    val chevronRotation by animateFloatAsState(
        targetValue = if (expanded) 180f else 0f,
        animationSpec = tween(260, easing = FastOutSlowInEasing),
        label = "super_admin_rail_group_chevron"
    )
    Column(
        modifier = Modifier.animateContentSize(
            animationSpec = tween(260, easing = FastOutSlowInEasing)
        ),
        verticalArrangement = Arrangement.spacedBy(if (compact) 6.dp else 8.dp)
    ) {
        RailTooltip(label = title, enabled = compact) {
            Row(
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(12.dp))
                .clickable(onClick = onToggleExpanded)
                .padding(horizontal = if (compact) 0.dp else 6.dp, vertical = if (compact) 10.dp else 12.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = if (compact) Arrangement.Center else Arrangement.spacedBy(14.dp)
        ) {
            RailGroupIcon(icon = icon, compact = compact, isActive = isActive)
            AnimatedVisibility(
                visible = !compact,
                enter = railLabelEnter(),
                exit = railLabelExit(),
                modifier = Modifier.weight(1f)
            ) {
                Text(
                    text = title,
                    style = MaterialTheme.typography.bodyLarge,
                    fontWeight = if (isActive) FontWeight.Bold else FontWeight.Normal,
                    color = if (isActive) HomeRailSelected else HomeTextSecondary
                )
            }
            AnimatedVisibility(visible = !compact) {
                Icon(
                    painter = homeIconPainter("chevron_down"),
                    contentDescription = if (expanded) "Collapse $title" else "Expand $title",
                    tint = HomeTextPrimary,
                    modifier = Modifier.size(18.dp).rotate(chevronRotation)
                )
            }
            }
        }

        AnimatedVisibility(
            visible = compact || expanded,
            enter = railChildrenEnter(),
            exit = railChildrenExit()
        ) {
            Column(modifier = Modifier.padding(start = if (compact) 0.dp else 14.dp)) {
                children.forEach { child ->
                    RailChildItem(child = child, compact = compact, onClick = { onItemClick(child) })
                }
            }
        }
    }
}

@Composable
private fun RailGroupIcon(
    icon: String,
    compact: Boolean,
    isActive: Boolean
) {
    if (compact) {
        Box(
            modifier = Modifier
                .size(38.dp)
                .clip(RoundedCornerShape(11.dp))
                .background(if (isActive) HomeRailSelectedSoft else Color(0xFFF3F6FC)),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = homeIconPainter(icon),
                contentDescription = null,
                tint = if (isActive) HomeRailSelected else HomeTextPrimary,
                modifier = Modifier.size(22.dp)
            )
        }
    } else {
        Icon(
            painter = homeIconPainter(icon),
            contentDescription = null,
            tint = if (isActive) HomeRailSelected else HomeTextPrimary,
            modifier = Modifier.size(20.dp)
        )
    }
}

@Composable
private fun RailChildItem(
    child: NavItem,
    compact: Boolean,
    onClick: () -> Unit
) {
    RailTooltip(label = child.title, enabled = compact) {
        Row(
            modifier = Modifier
            .fillMaxWidth()
            .height(40.dp)
            .clip(RoundedCornerShape(10.dp))
            .background(if (compact && child.isActive) HomeRailSelectedSoft else Color.Transparent)
            .clickable(onClick = onClick),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = if (compact) Arrangement.Center else Arrangement.Start
        ) {
        if (compact) {
            Box(
                modifier = Modifier
                    .size(34.dp)
                    .clip(RoundedCornerShape(9.dp))
                    .background(if (child.isActive) HomeRailSelectedSoft else Color.Transparent),
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    painter = homeIconPainter(child.icon),
                    contentDescription = child.title,
                    tint = if (child.isActive) HomeRailSelected else HomeTextSecondary,
                    modifier = Modifier.size(17.dp)
                )
            }
        } else {
            Box(
                modifier = Modifier
                    .width(22.dp)
                    .height(40.dp),
                contentAlignment = Alignment.Center
            ) {
                Box(
                    modifier = Modifier
                        .width(1.dp)
                        .height(40.dp)
                        .background(HomeBorder)
                )
                Box(
                    modifier = Modifier
                        .size(4.dp)
                        .clip(CircleShape)
                        .background(HomeTextMuted)
                )
            }
            Text(
                text = child.title,
                style = MaterialTheme.typography.bodyMedium,
                fontWeight = if (child.isActive) FontWeight.Bold else FontWeight.Normal,
                color = if (child.isActive) HomeRailSelected else HomeTextSecondary,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
                modifier = Modifier.padding(start = 2.dp)
            )
        }
        }
    }
}

@Composable
private fun SuperAdminRailFooter(
    compact: Boolean,
    onToggleCollapse: () -> Unit
) {
    Column(modifier = Modifier.fillMaxWidth()) {
        HorizontalDivider(color = HomeBorder)
        Spacer(modifier = Modifier.height(10.dp))
        SuperAdminFooterItem(
            icon = if (compact) "chevron_right" else "chevron_left",
            label = if (compact) "Expand Menu" else "Collapse Menu",
            compact = compact,
            onClick = onToggleCollapse
        )
    }
}

@Composable
private fun SuperAdminFooterItem(
    icon: String,
    label: String,
    compact: Boolean,
    onClick: () -> Unit
) {
    RailTooltip(label = label, enabled = compact) {
        Row(
            modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .clickable(onClick = onClick)
            .padding(horizontal = if (compact) 8.dp else 6.dp, vertical = 10.dp),
        horizontalArrangement = if (compact) Arrangement.Center else Arrangement.spacedBy(14.dp),
        verticalAlignment = Alignment.CenterVertically
        ) {
        Icon(
            painter = homeIconPainter(icon),
            contentDescription = label,
            tint = HomeTextPrimary,
            modifier = Modifier.size(20.dp)
        )
        AnimatedVisibility(visible = !compact) {
            Text(
                text = label,
                style = MaterialTheme.typography.bodyLarge,
                fontWeight = FontWeight.Normal,
                color = HomeTextSecondary
            )
        }
        }
    }
}

@Composable
private fun TeacherExpandableRailItem(
    item: NavItem,
    compact: Boolean,
    expanded: Boolean,
    onToggleExpanded: () -> Unit,
    onItemClick: (NavItem) -> Unit
) {
    val isActive = item.children.any { it.isActive }
    val chevronRotation by animateFloatAsState(
        targetValue = if (expanded) 180f else 0f,
        animationSpec = tween(260, easing = FastOutSlowInEasing),
        label = "rail_group_chevron"
    )
    Column(
        modifier = Modifier.animateContentSize(
            animationSpec = tween(260, easing = FastOutSlowInEasing)
        ),
        verticalArrangement = Arrangement.spacedBy(if (compact) 6.dp else 8.dp)
    ) {
        RailTooltip(label = item.title, enabled = compact) {
            Row(
                modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(12.dp))
                .clickable(onClick = onToggleExpanded)
                .padding(horizontal = if (compact) 0.dp else 6.dp, vertical = if (compact) 10.dp else 12.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = if (compact) Arrangement.Center else Arrangement.spacedBy(14.dp)
        ) {
            RailGroupIcon(icon = item.icon, compact = compact, isActive = isActive)
            AnimatedVisibility(
                visible = !compact,
                enter = railLabelEnter(),
                exit = railLabelExit(),
                modifier = Modifier.weight(1f)
            ) {
                Text(
                    text = item.title,
                    style = MaterialTheme.typography.bodyLarge,
                    fontWeight = if (isActive) FontWeight.Bold else FontWeight.Normal,
                    color = if (isActive) HomeRailSelected else HomeTextSecondary
                )
            }
            AnimatedVisibility(
                visible = !compact,
                enter = fadeIn(tween(220)),
                exit = fadeOut(tween(140))
            ) {
                Icon(
                    painter = homeIconPainter("chevron_down"),
                    contentDescription = if (expanded) "Collapse ${item.title}" else "Expand ${item.title}",
                    tint = HomeTextPrimary,
                    modifier = Modifier.size(18.dp).rotate(chevronRotation)
                )
            }
            }
        }
        AnimatedVisibility(
            visible = compact || expanded,
            enter = railChildrenEnter(),
            exit = railChildrenExit()
        ) {
            Column(modifier = Modifier.padding(start = if (compact) 0.dp else 14.dp)) {
                item.children.forEach { child ->
                    RailChildItem(child = child, compact = compact, onClick = { onItemClick(child) })
                }
            }
        }
    }
}

@Composable
private fun HomeSidebarFooter(
    compact: Boolean,
    onToggleCollapse: () -> Unit
) {
    RailTooltip(label = if (compact) "Expand Menu" else "Collapse Menu", enabled = compact) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(12.dp))
                .clickable(onClick = onToggleCollapse)
                .padding(horizontal = if (compact) 8.dp else 10.dp, vertical = if (compact) 10.dp else 8.dp),
            horizontalArrangement = if (compact) Arrangement.Center else Arrangement.spacedBy(10.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
        Icon(
            painter = homeIconPainter(if (compact) "chevron_right" else "chevron_left"),
            contentDescription = null,
            tint = HomeTextPrimary,
            modifier = Modifier.size(18.dp)
        )
        AnimatedVisibility(
            visible = !compact,
            enter = railLabelEnter(),
            exit = railLabelExit()
        ) {
            Text(
                text = "Collapse Menu",
                style = MaterialTheme.typography.bodyMedium,
                fontWeight = FontWeight.SemiBold,
                color = HomeTextPrimary
            )
        }
        }
    }
}

@Composable
private fun TeacherRailBrand(
    schoolName: String,
    academicYearLabel: String,
    compact: Boolean
) {
    if (compact) {
        Box(
            modifier = Modifier
                .size(56.dp)
                .clip(RoundedCornerShape(18.dp))
                .background(HomeBlueSoft)
                .border(2.dp, HomeBlue, RoundedCornerShape(18.dp)),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = homeIconPainter("graduation_cap"),
                contentDescription = schoolName,
                tint = HomeBlue,
                modifier = Modifier.size(34.dp)
            )
        }
    } else {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 12.dp, vertical = 6.dp),
            verticalArrangement = Arrangement.spacedBy(10.dp)
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                Box(
                    modifier = Modifier
                        .size(52.dp)
                        .clip(CircleShape)
                        .background(HomeBlueSoft)
                        .border(2.dp, HomeBlue, CircleShape),
                    contentAlignment = Alignment.Center
                ) {
                    Icon(
                        painter = homeIconPainter("graduation_cap"),
                        contentDescription = schoolName,
                        tint = HomeBlue,
                        modifier = Modifier.size(30.dp)
                    )
                }
                Text(
                    text = schoolName.ifBlank { "iConnect.School" },
                    style = MaterialTheme.typography.titleLarge,
                    color = HomeTextPrimary,
                    fontWeight = FontWeight.Bold,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis
                )
            }
            if (academicYearLabel.isNotBlank()) {
                Text(
                    text = academicYearLabel,
                    style = MaterialTheme.typography.titleSmall,
                    color = HomeTextPrimary,
                    fontWeight = FontWeight.SemiBold
                )
            }
            HorizontalDivider(color = HomeBorder)
        }
    }
}

@Composable
private fun TeacherRailFooter(
    compact: Boolean,
    onToggleCollapse: () -> Unit
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(if (compact) 8.dp else 10.dp)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .clip(RoundedCornerShape(16.dp))
                .padding(horizontal = if (compact) 8.dp else 10.dp, vertical = if (compact) 8.dp else 10.dp),
            horizontalArrangement = if (compact) Arrangement.Center else Arrangement.spacedBy(10.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = homeIconPainter("ic_launcher"),
                contentDescription = "iConnect.School",
                tint = Color.Unspecified,
                modifier = Modifier.size(if (compact) 24.dp else 28.dp)
            )
            AnimatedVisibility(
                visible = !compact,
                enter = railLabelEnter(),
                exit = railLabelExit()
            ) {
                AppBrandWordmark(
                    style = MaterialTheme.typography.bodyLarge,
                    fontWeight = FontWeight.SemiBold
                )
            }
        }
        RailTooltip(label = if (compact) "Expand Menu" else "Collapse Menu", enabled = compact) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(12.dp))
                    .clickable(onClick = onToggleCollapse)
                    .padding(horizontal = if (compact) 8.dp else 10.dp, vertical = if (compact) 10.dp else 8.dp),
                horizontalArrangement = if (compact) Arrangement.Center else Arrangement.spacedBy(10.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
            Icon(
                painter = homeIconPainter(if (compact) "chevron_right" else "chevron_left"),
                contentDescription = null,
                tint = HomeTextPrimary,
                modifier = Modifier.size(18.dp)
            )
            AnimatedVisibility(
                visible = !compact,
                enter = railLabelEnter(),
                exit = railLabelExit()
            ) {
                Text(
                    text = "Collapse Menu",
                    style = MaterialTheme.typography.bodyMedium,
                    fontWeight = FontWeight.SemiBold,
                    color = HomeTextPrimary
                )
            }
            }
        }
    }
}

@Composable
private fun TeacherReferenceRailFooter(
    compact: Boolean,
    onToggleCollapse: () -> Unit
) {
    Column(modifier = Modifier.fillMaxWidth()) {
        HorizontalDivider(color = HomeBorder)
        Spacer(modifier = Modifier.height(10.dp))
        SuperAdminFooterItem(
            icon = if (compact) "chevron_right" else "chevron_left",
            label = if (compact) "Expand Menu" else "Collapse Menu",
            compact = compact,
            onClick = onToggleCollapse
        )
        Spacer(modifier = Modifier.height(8.dp))
        HorizontalDivider(color = HomeBorder)
        Spacer(modifier = Modifier.height(8.dp))
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = if (compact) 8.dp else 6.dp, vertical = 4.dp),
            horizontalArrangement = if (compact) Arrangement.Center else Arrangement.spacedBy(10.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Icon(
                painter = homeIconPainter("ic_launcher"),
                contentDescription = "iConnect.School",
                tint = Color.Unspecified,
                modifier = Modifier.size(if (compact) 24.dp else 28.dp)
            )
            AnimatedVisibility(visible = !compact) {
                Column(verticalArrangement = Arrangement.spacedBy(2.dp)) {
                    AppBrandWordmark(
                        style = MaterialTheme.typography.bodyMedium,
                        fontWeight = FontWeight.Bold
                    )
                    Text(
                        text = "Powered by iConnect.School",
                        style = MaterialTheme.typography.labelSmall,
                        color = HomeTextMuted,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
            }
        }
    }
}

@Composable
private fun CompactTopBar(
    state: HomeUiState,
    onEvent: (HomeUiEvent) -> Unit,
    onLogout: () -> Unit,
    onEditProfile: () -> Unit
) {
    val referenceHeaderRole = state.roleCode == SchoolKeys.V_ROLE_PARENT ||
        state.roleCode == SchoolKeys.V_ROLE_TEACHER ||
        state.roleCode == SchoolKeys.V_ROLE_SCHOOL_ADMIN ||
        state.roleCode == SchoolKeys.V_ROLE_APP_SUPER_ADMIN
    if (referenceHeaderRole) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .background(Color.White)
                .padding(horizontal = 18.dp, vertical = 14.dp)
        ) {
            HomeHeader(
                state = state,
                onEvent = onEvent,
                onLogout = onLogout,
                onEditProfile = onEditProfile
            )
        }
        return
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .background(Color.White)
            .padding(horizontal = 18.dp, vertical = 14.dp),
        verticalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        SidebarBrand(compact = false)
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Column(
                modifier = Modifier.weight(1f),
                verticalArrangement = Arrangement.spacedBy(2.dp)
            ) {
                Text(
                    text = "Good Morning, ${state.roleLabel}!",
                    style = MaterialTheme.typography.titleLarge,
                    fontWeight = FontWeight.Bold,
                    color = HomeTextPrimary,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = "Here's what's happening with iConnect.School today.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = HomeTextSecondary,
                    maxLines = 2,
                    overflow = TextOverflow.Ellipsis
                )
            }
            ShellTopRightActions(
                roleLabel = state.roleLabel,
                roleSubtitle = state.roleSubtitle,
                initials = shellAvatarInitials(state.userProfile.fullName.ifBlank { state.roleLabel }),
                expanded = state.isAccountMenuExpanded,
                onExpandedChange = { expanded ->
                    onEvent(if (expanded) HomeUiEvent.AccountMenuToggled else HomeUiEvent.AccountMenuDismissed)
                },
            onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
            onLogout = onLogout,
            onMyProfile = onEditProfile,
            profileName = state.userProfile.fullName,
            profileEmail = state.userProfile.email,
            forceCompact = true
            )
        }
    }
}

@Composable
private fun MainHomeContent(
    state: HomeUiState,
    content: HomeDashboardContent,
    onEvent: (HomeUiEvent) -> Unit,
    onToggleTheme: () -> Unit,
    onLogout: () -> Unit,
    onEditProfile: () -> Unit,
    modifier: Modifier = Modifier,
    contentWidth: androidx.compose.ui.unit.Dp,
    metricColumns: Int
) {
    AppScreenTransition(
        targetState = state.selectedNavId,
        modifier = modifier
    ) { selectedNavId ->
        MainHomeContentBody(
            state = state.copy(selectedNavId = selectedNavId),
            content = content,
            onEvent = onEvent,
            onToggleTheme = onToggleTheme,
            onLogout = onLogout,
            onEditProfile = onEditProfile,
            modifier = Modifier.fillMaxSize(),
            contentWidth = contentWidth,
            metricColumns = metricColumns
        )
    }
}

@Composable
private fun MainHomeContentBody(
    state: HomeUiState,
    content: HomeDashboardContent,
    onEvent: (HomeUiEvent) -> Unit,
    onToggleTheme: () -> Unit,
    onLogout: () -> Unit,
    onEditProfile: () -> Unit,
    modifier: Modifier = Modifier,
    contentWidth: androidx.compose.ui.unit.Dp,
    metricColumns: Int
) {
    if (state.roleCode == SchoolKeys.V_ROLE_TEACHER && state.selectedNavId == "students") {
        val myStudentsViewModel = remember(state.railActivationKey, state.schoolId) { TeacherMyStudentsViewModel() }
        val myStudentsUiState by myStudentsViewModel.uiState.collectAsState()
        DisposableEffect(myStudentsViewModel) {
            onDispose { myStudentsViewModel.clear() }
        }
        Box(modifier = modifier.fillMaxSize()) {
            TeacherMyStudentsScreen(
                state = myStudentsUiState,
                onEvent = myStudentsViewModel::onEvent,
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                shellSchoolLabel = state.schoolLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_TEACHER && state.selectedNavId == "attendance") {
        val attendanceViewModel = remember(state.railActivationKey, state.schoolId) { AttendanceViewModel() }
        val attendanceUiState by attendanceViewModel.uiState.collectAsState()
        DisposableEffect(attendanceViewModel) {
            onDispose { attendanceViewModel.clear() }
        }
        Box(modifier = modifier.fillMaxSize()) {
            AttendanceScreen(
                state = attendanceUiState,
                onEvent = attendanceViewModel::onEvent,
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                shellSchoolLabel = state.schoolLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_TEACHER && state.selectedNavId == "document-library") {
        val documentLibraryViewModel = remember(state.railActivationKey, state.schoolId) {
            DocumentLibraryViewModel(state.schoolId)
        }
        val documentLibraryUiState by documentLibraryViewModel.uiState.collectAsState()
        DisposableEffect(documentLibraryViewModel) {
            onDispose { documentLibraryViewModel.clear() }
        }
        Box(modifier = modifier.fillMaxSize()) {
            DocumentLibraryScreen(
                uiState = documentLibraryUiState,
                onQueryChanged = documentLibraryViewModel::onQueryChanged,
                onCategoryChanged = documentLibraryViewModel::onCategoryChanged,
                onApplicableToChanged = documentLibraryViewModel::onApplicableToChanged,
                onClearFilters = documentLibraryViewModel::clearFilters,
                onPageChanged = documentLibraryViewModel::onPageChanged,
                onPageSizeChanged = documentLibraryViewModel::onPageSizeChanged,
                onSortChanged = documentLibraryViewModel::onSortChanged,
                onCreateDocument = { draft, onSuccess ->
                    documentLibraryViewModel.createDocument(
                        draft.title,
                        draft.description,
                        draft.category,
                        draft.applicableTo,
                        draft.filename,
                        draft.contentType,
                        draft.bytes,
                        draft.classTargetIds
                    ) { if (it == null) onSuccess() }
                },
                onUpdateDocument = { id, title, description, category, applicableTo, classTargetIds, onSuccess ->
                    documentLibraryViewModel.updateDocument(id, title, description, category, applicableTo, classTargetIds) { if (it == null) onSuccess() }
                },
                canEdit = false,
                classOptions = documentLibraryUiState.classOptions,
                isLoadingClassOptions = documentLibraryUiState.isLoadingClassOptions,
                classOptionsError = documentLibraryUiState.classOptionsError,
                categoryOptions = documentLibraryUiState.categoryOptions,
                audienceOptions = documentLibraryUiState.audienceOptions,
                isLoadingLookupOptions = documentLibraryUiState.isLoadingLookupOptions,
                lookupOptionsError = documentLibraryUiState.lookupOptionsError,
                schoolLabel = state.schoolLabel,
                academicYearLabel = state.activeAcademicYearLabel,
                headerActions = {
                    ShellTopRightActions(
                        roleLabel = state.roleLabel,
                        roleSubtitle = state.roleSubtitle,
                        initials = shellAvatarInitials(state.userProfile.fullName.ifBlank { state.roleLabel }),
                        expanded = state.isAccountMenuExpanded,
                        onExpandedChange = { expanded ->
                            onEvent(if (expanded) HomeUiEvent.AccountMenuToggled else HomeUiEvent.AccountMenuDismissed)
                        },
                        onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                        onLogout = onLogout,
                        profileName = state.userProfile.fullName,
                        profileEmail = state.userProfile.email
                    )
                },
                onLoadDocumentDetails = documentLibraryViewModel::loadDocumentDetails,
                onDownload = documentLibraryViewModel::download,
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) }
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_PARENT && state.selectedNavId == "document-library") {
        val parentDocumentChildren = parentLinkedChildren(state)
        val parentDocumentViewModel = remember(state.railActivationKey, state.schoolId, parentDocumentChildren) { ParentDocumentLibraryViewModel(parentDocumentChildren) }
        val parentDocumentUiState by parentDocumentViewModel.uiState.collectAsState()
        DisposableEffect(parentDocumentViewModel) {
            onDispose { parentDocumentViewModel.clear() }
        }
        Box(modifier = modifier.fillMaxSize()) {
            ParentDocumentLibraryScreen(
                uiState = parentDocumentUiState,
                onQueryChanged = parentDocumentViewModel::queryChanged,
                onCategoryChanged = parentDocumentViewModel::categoryChanged,
                onPageChanged = parentDocumentViewModel::pageChanged,
                onPageSizeChanged = parentDocumentViewModel::pageSizeChanged,
                onSortChanged = parentDocumentViewModel::sortChanged,
                onLoadDocumentDetails = parentDocumentViewModel::loadDocumentDetails,
                onDownload = parentDocumentViewModel::download,
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout,
                onRetryLookupOptions = parentDocumentViewModel::retryLookupOptions,
                categoryOptions = parentDocumentUiState.categoryOptions,
                isLoadingLookupOptions = parentDocumentUiState.isLoadingLookupOptions,
                lookupOptionsError = parentDocumentUiState.lookupOptionsError
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_PARENT && state.selectedNavId == "attendance") {
        val parentAttendanceChildren = parentLinkedChildren(state)
        val parentAttendanceViewModel = remember(state.railActivationKey, state.schoolId, parentAttendanceChildren) { ParentAttendanceViewModel(parentAttendanceChildren) }
        val parentAttendanceUiState by parentAttendanceViewModel.uiState.collectAsState()
        DisposableEffect(parentAttendanceViewModel) {
            onDispose { parentAttendanceViewModel.clear() }
        }
        Box(modifier = modifier.fillMaxSize()) {
            ParentAttendanceScreen(
                state = parentAttendanceUiState,
                onEvent = parentAttendanceViewModel::onEvent,
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_TEACHER && state.selectedNavId == "homework") {
        val homeworkViewModel = remember(state.railActivationKey, state.schoolId) { HomeworkViewModel(schoolId = state.schoolId) }
        val homeworkUiState by homeworkViewModel.uiState.collectAsState()
        DisposableEffect(homeworkViewModel) {
            onDispose { homeworkViewModel.clear() }
        }
        Box(modifier = modifier.fillMaxSize()) {
            HomeworkScreen(
                state = homeworkUiState,
                onEvent = homeworkViewModel::onEvent,
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                shellSchoolLabel = state.schoolLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_PARENT && state.selectedNavId == "homework") {
        val parentHomeworkChildren = parentLinkedChildren(state)
        val parentHomeworkViewModel = remember(state.railActivationKey, state.schoolId, parentHomeworkChildren) { ParentHomeworkViewModel(parentHomeworkChildren) }
        val parentHomeworkUiState by parentHomeworkViewModel.uiState.collectAsState()
        DisposableEffect(parentHomeworkViewModel) {
            onDispose { parentHomeworkViewModel.clear() }
        }
        Box(modifier = modifier.fillMaxSize()) {
            ParentHomeworkScreen(
                state = parentHomeworkUiState,
                onEvent = parentHomeworkViewModel::onEvent,
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_TEACHER && state.selectedNavId == "notices") {
        val noticesViewModel = remember(state.railActivationKey, state.schoolId) { NoticesViewModel() }
        val noticesUiState by noticesViewModel.uiState.collectAsState()
        DisposableEffect(noticesViewModel) {
            onDispose { noticesViewModel.clear() }
        }
        Box(modifier = modifier.fillMaxSize()) {
            NoticesScreen(
                state = noticesUiState,
                onEvent = noticesViewModel::onEvent,
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_TEACHER && state.selectedNavId == "quick-announcements") {
        val quickAnnouncementsViewModel = remember(state.railActivationKey, state.schoolId) { QuickAnnouncementsViewModel() }
        val quickAnnouncementsState by quickAnnouncementsViewModel.uiState.collectAsState()
        Box(modifier = modifier.fillMaxSize()) {
            QuickAnnouncementsScreen(
                state = quickAnnouncementsState,
                onEvent = quickAnnouncementsViewModel::onEvent,
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout,
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) }
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_PARENT && state.selectedNavId == "notices") {
        val parentNoticeChildren = parentLinkedChildren(state)
        val parentNoticesViewModel = remember(state.railActivationKey, state.schoolId, parentNoticeChildren) { ParentNoticesViewModel(parentNoticeChildren) }
        val parentNoticesUiState by parentNoticesViewModel.uiState.collectAsState()
        Box(modifier = modifier.fillMaxSize()) {
            ParentNoticesScreen(
                state = parentNoticesUiState,
                onEvent = parentNoticesViewModel::onEvent,
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_TEACHER && state.selectedNavId == "events-news") {
        val eventsNewsViewModel = remember(state.railActivationKey, state.schoolId) { EventsNewsViewModel(state.schoolId) }
        val eventsNewsUiState by eventsNewsViewModel.uiState.collectAsState()
        DisposableEffect(eventsNewsViewModel) { onDispose { eventsNewsViewModel.clear() } }
        Box(modifier = modifier.fillMaxSize()) {
            EventsNewsScreen(
                state = eventsNewsUiState,
                onEvent = eventsNewsViewModel::onEvent,
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_PARENT && state.selectedNavId == "events-news") {
        val parentEventChildren = parentLinkedChildren(state)
        val parentEventsNewsViewModel = remember(state.railActivationKey, state.schoolId, parentEventChildren) { ParentEventsNewsViewModel(parentEventChildren) }
        val parentEventsNewsState by parentEventsNewsViewModel.state.collectAsState()
        Box(modifier = modifier.fillMaxSize()) {
            ParentEventsNewsScreen(parentEventsNewsState, parentEventsNewsViewModel::onEvent, state.roleCode, { onEvent(HomeUiEvent.RolePickerRequested) }, onLogout)
        }
        return
    }

    if ((state.roleCode == SchoolKeys.V_ROLE_TEACHER || state.roleCode == SchoolKeys.V_ROLE_PARENT) && state.selectedNavId == "calendar") {
        val calendarChildren = if (state.roleCode == SchoolKeys.V_ROLE_PARENT) parentLinkedChildren(state) else emptyList()
        val calendarViewModel = remember(state.railActivationKey, state.schoolId, state.roleCode, state.activeAcademicYearId, calendarChildren) {
            CalendarViewModel(
                academicYearId = state.activeAcademicYearId,
                children = calendarChildren,
                useTeacherEventsApi = state.roleCode == SchoolKeys.V_ROLE_TEACHER,
                useParentEventsApi = state.roleCode == SchoolKeys.V_ROLE_PARENT
            )
        }
        val calendarUiState by calendarViewModel.uiState.collectAsState()
        DisposableEffect(calendarViewModel) { onDispose { calendarViewModel.clear() } }
        Box(modifier = modifier.fillMaxSize()) {
            CalendarScreen(
                state = calendarUiState.copy(listView = false),
                onEvent = calendarViewModel::onEvent,
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                contextLine = if (state.roleCode == SchoolKeys.V_ROLE_PARENT) "School calendar | AY 2026–27" else "School calendar | 2026–27",
                readOnly = true,
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout,
                parentChildren = calendarChildren
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_PARENT && state.selectedNavId == "time-table") {
        val parentTimeTableChildren = parentLinkedChildren(state)
        val parentTimeTableViewModel = remember(state.railActivationKey, parentTimeTableChildren) { ParentTimeTableViewModel(parentTimeTableChildren) }
        val parentTimeTableUiState by parentTimeTableViewModel.uiState.collectAsState()
        DisposableEffect(parentTimeTableViewModel) { onDispose { parentTimeTableViewModel.clear() } }
        Box(modifier = modifier.fillMaxSize()) {
            ParentTimeTableScreen(
                state = parentTimeTableUiState,
                onEvent = parentTimeTableViewModel::onEvent,
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_TEACHER && state.selectedNavId == "parent-notes") {
        val parentNotesViewModel = remember(state.railActivationKey, state.schoolId) { ParentNotesViewModel(state.schoolId) }
        val parentNotesUiState by parentNotesViewModel.uiState.collectAsState()
        DisposableEffect(parentNotesViewModel) {
            onDispose { parentNotesViewModel.clear() }
        }
        Box(modifier = modifier.fillMaxSize()) {
            ParentNotesScreen(
                state = parentNotesUiState,
                onEvent = parentNotesViewModel::onEvent,
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                shellSchoolLabel = state.schoolLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_PARENT && state.selectedNavId == "parent-notes") {
        val parentNoteChildren = parentLinkedChildren(state)
        val parentPortalNotesViewModel = remember(state.railActivationKey, state.schoolId, parentNoteChildren) { ParentPortalNotesViewModel(parentNoteChildren) }
        val parentPortalNotesState by parentPortalNotesViewModel.state.collectAsState()
        DisposableEffect(parentPortalNotesViewModel) { onDispose { parentPortalNotesViewModel.clear() } }
        Box(modifier = modifier.fillMaxSize()) {
            ParentPortalNotesScreen(parentPortalNotesState, parentPortalNotesViewModel::onEvent, state.roleCode, { onEvent(HomeUiEvent.RolePickerRequested) }, onLogout)
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_TEACHER && state.selectedNavId == "time-table") {
        val teacherTimeTableViewModel = remember(state.railActivationKey, state.schoolId, state.activeAcademicYearId) {
            com.schoolconnect.app.feature.timetable.TeacherTimeTableViewModel(
                roleCode = state.roleCode,
                schoolId = state.schoolId,
                academicYearId = state.activeAcademicYearId
            )
        }
        val teacherTimeTableUiState by teacherTimeTableViewModel.uiState.collectAsState()
        DisposableEffect(teacherTimeTableViewModel) { onDispose { teacherTimeTableViewModel.clear() } }
        Box(modifier = modifier.fillMaxSize()) {
            TeacherTimeTableScreen(
                state = teacherTimeTableUiState,
                onEvent = teacherTimeTableViewModel::onEvent,
                headerActions = {
                    ShellTopRightActions(
                        roleLabel = state.roleLabel,
                        roleSubtitle = state.roleSubtitle,
                        initials = shellAvatarInitials(state.userProfile.fullName.ifBlank { state.roleLabel }),
                        expanded = state.isAccountMenuExpanded,
                        onExpandedChange = { expanded ->
                            onEvent(if (expanded) HomeUiEvent.AccountMenuToggled else HomeUiEvent.AccountMenuDismissed)
                        },
                        onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                        onLogout = onLogout,
                        onMyProfile = onEditProfile,
                        profileName = state.userProfile.fullName,
                        profileEmail = state.userProfile.email,
                    )
                }
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_TEACHER && state.selectedNavId == "class-conversations") {
        val teacherConversationsViewModel = remember(state.railActivationKey, state.schoolId) { ClassConversationsViewModel(schoolId = state.schoolId) }
        val teacherConversationsState by teacherConversationsViewModel.uiState.collectAsState()
        DisposableEffect(teacherConversationsViewModel) { onDispose { teacherConversationsViewModel.close() } }
        Box(modifier = modifier.fillMaxSize()) {
            AdminClassConversationsApiScreen(
                state = teacherConversationsState,
                onEvent = teacherConversationsViewModel::onEvent,
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_PARENT && state.selectedNavId == "class-conversations") {
        val parentConversationChildren = parentLinkedChildren(state)
        val globalSelectedConversationChildId by ParentChildSelectionStore.selectedChildId.collectAsState()
        val selectedConversationChildId = globalSelectedConversationChildId.takeIf { id -> parentConversationChildren.any { it.id == id } }
            ?: parentConversationChildren.firstOrNull()?.id
        val conversationsViewModel = remember(state.railActivationKey, state.schoolId, selectedConversationChildId) { ClassConversationsViewModel(selectedConversationChildId) }
        val conversationsApiState by conversationsViewModel.uiState.collectAsState()
        DisposableEffect(conversationsViewModel) { onDispose { conversationsViewModel.close() } }
        Box(modifier = modifier.fillMaxSize()) {
            ClassConversationsScreen(
                shellRoleCode = state.roleCode,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout,
                apiState = conversationsApiState,
                onApiEvent = conversationsViewModel::onEvent,
                classGroupLabel = parentConversationChildren.firstOrNull { it.id == selectedConversationChildId }?.classLabel?.let { "Class $it" } ?: "Class —"
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_SCHOOL_ADMIN && state.selectedNavId == "support-center") {
        Box(modifier = modifier.fillMaxSize()) {
            SupportCenterScreen(
                schoolLabel = state.schoolLabel,
                roleCode = state.roleCode,
                roleLabel = state.roleLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout,
                onOpenDocumentLibrary = { onEvent(HomeUiEvent.NavSelected("document-library")) }
            )
        }
        return
    }

    if (state.roleCode in setOf(SchoolKeys.V_ROLE_TEACHER, SchoolKeys.V_ROLE_PARENT) && state.selectedNavId == "help-desk") {
        Box(modifier = modifier.fillMaxSize()) {
            SupportCenterScreen(
                schoolLabel = state.schoolLabel,
                roleCode = state.roleCode,
                roleLabel = state.roleLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout,
                onOpenDocumentLibrary = { onEvent(HomeUiEvent.NavSelected("document-library")) }
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_APP_SUPER_ADMIN && state.selectedNavId == "help-desk") {
        Box(modifier = Modifier.fillMaxSize()) {
            SuperAdminSupportQueueScreen(
                roleLabel = state.roleLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_TEACHER && state.selectedNavId in setOf("exams", "exam-setup")) {
        val examsViewModel = remember(state.railActivationKey, state.schoolId) { ExamsViewModel(schoolId = state.schoolId) }
        val examsUiState by examsViewModel.uiState.collectAsState()
        DisposableEffect(examsViewModel) {
            onDispose { examsViewModel.clear() }
        }
        Box(modifier = modifier.fillMaxSize()) {
            ExamsScreen(
                state = examsUiState,
                onEvent = examsViewModel::onEvent,
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                shellSchoolLabel = state.schoolLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_TEACHER && state.selectedNavId == "exam-results") {
        val examResultsViewModel = remember(state.railActivationKey, state.schoolId) { ExamResultsViewModel() }
        val examResultsUiState by examResultsViewModel.uiState.collectAsState()
        DisposableEffect(examResultsViewModel) {
            onDispose { examResultsViewModel.clear() }
        }
        Box(modifier = modifier.fillMaxSize()) {
            ExamResultsScreen(
                state = examResultsUiState,
                onEvent = examResultsViewModel::onEvent,
                onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
                shellRoleCode = state.roleCode,
                shellSchoolLabel = state.schoolLabel,
                onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
                onLogout = onLogout
            )
        }
        return
    }

    if (state.roleCode == SchoolKeys.V_ROLE_PARENT && state.selectedNavId == "exam-results") {
        val parentExamChildren = remember(state.parentProfile?.students, state.parentDashboard?.children) {
            val dashboardByStudentId = state.parentDashboard?.children.orEmpty()
                .mapNotNull { child -> child.studentId?.trim()?.takeIf(String::isNotBlank)?.let { it to child } }
                .toMap()
            val profileChildren = state.parentProfile?.students.orEmpty().mapNotNull { student ->
                val id = student.studentId?.trim().orEmpty()
                id.takeIf { it.isNotBlank() }?.let {
                    com.schoolconnect.app.feature.attendance.ParentAttendanceChild(
                        id = it,
                        name = student.studentName.orEmpty().ifBlank { "Student" },
                        rollNumber = dashboardByStudentId[it]?.rollNumber.orEmpty().ifBlank { "—" },
                        classLabel = listOfNotNull(student.className, student.sectionName).joinToString("-").ifBlank { "—" }
                    )
                }
            }
            if (profileChildren.isNotEmpty()) profileChildren else state.parentDashboard?.children.orEmpty().mapNotNull { student ->
                val id = student.studentId?.trim().orEmpty()
                id.takeIf { it.isNotBlank() }?.let {
                    com.schoolconnect.app.feature.attendance.ParentAttendanceChild(
                        id = it,
                        name = student.studentName.orEmpty().ifBlank { "Student" },
                        rollNumber = student.rollNumber.orEmpty().ifBlank { "—" },
                        classLabel = "—"
                    )
                }
            }
        }
        val parentExamResultsViewModel = remember(state.railActivationKey, state.schoolId, parentExamChildren) { ParentExamResultsViewModel(parentExamChildren) }
        val parentExamResultsState by parentExamResultsViewModel.state.collectAsState()
        DisposableEffect(parentExamResultsViewModel) { onDispose { parentExamResultsViewModel.clear() } }
        Box(modifier = modifier.fillMaxSize()) {
            ParentExamResultsScreen(parentExamResultsState, parentExamResultsViewModel::onEvent, state.roleCode, { onEvent(HomeUiEvent.RolePickerRequested) }, onLogout)
        }
        return
    }

    if (state.selectedNavId == "schools") {
        SchoolsFeatureRoute(
            onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
            shellRoleCode = state.roleCode,
            shellSchoolLabel = state.schoolLabel,
            onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
            onLogout = onLogout
        )
        return
    }

    if (state.selectedNavId == "school-users") {
        SchoolUsersFeatureRoute(
            onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
            shellRoleCode = state.roleCode,
            shellSchoolLabel = state.schoolLabel,
            onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
            onLogout = onLogout
        )
        return
    }

    if (state.selectedNavId == "it-users") {
        ITUsersFeatureRoute(
            onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
            shellRoleCode = state.roleCode,
            shellSchoolLabel = state.schoolLabel,
            onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
            onLogout = onLogout
        )
        return
    }

    if (state.selectedNavId == "academic-years") {
        AcademicYearsFeatureRoute(
            onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) },
            shellRoleCode = state.roleCode,
            shellSchoolLabel = state.schoolLabel,
            onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
            onLogout = onLogout
        )
        return
    }

    if (state.selectedNavId == "school-config" && state.roleCode == SchoolKeys.V_ROLE_APP_SUPER_ADMIN) {
        SchoolConfigFeatureRoute(
            roleLabel = state.roleLabel,
            roleSubtitle = state.roleSubtitle,
            onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
            onLogout = onLogout,
            onBack = { onEvent(HomeUiEvent.NavSelected("dashboard")) }
        )
        return
    }

    if (state.selectedNavId == "reports" && state.roleCode == SchoolKeys.V_ROLE_APP_SUPER_ADMIN) {
        Column(
            modifier = modifier
                .fillMaxSize()
                .padding(horizontal = 24.dp, vertical = 20.dp)
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .widthIn(max = contentWidth)
                    .align(Alignment.CenterHorizontally)
            ) {
                HomeHeader(
                    state = state,
                    onEvent = onEvent,
                    onLogout = onLogout,
                    onEditProfile = onEditProfile
                )
            }
            Spacer(Modifier.height(14.dp))
            ReportsFeatureRoute(
                modifier = Modifier
                    .fillMaxWidth()
                    .widthIn(max = contentWidth)
                    .align(Alignment.CenterHorizontally)
                    .weight(1f)
            )
        }
        return
    }

    if (state.selectedNavId == "analytics-reports" && state.roleCode == SchoolKeys.V_ROLE_PARENT) {
        val selectedChildId = LocalParentChildContext.current.selectedChildId
        val selectedChild = LocalParentChildContext.current.children.firstOrNull { it.id == selectedChildId }
        Column(
            modifier = modifier.fillMaxSize().padding(horizontal = 24.dp, vertical = 20.dp)
        ) {
            Box(
                modifier = Modifier.fillMaxWidth().widthIn(max = contentWidth).align(Alignment.CenterHorizontally)
            ) {
                HomeHeader(state, onEvent, onLogout, onEditProfile)
            }
            Spacer(Modifier.height(14.dp))
            ParentStudentPerformanceReport(
                child = selectedChild,
                modifier = Modifier.fillMaxWidth().widthIn(max = contentWidth).align(Alignment.CenterHorizontally).weight(1f)
            )
        }
        return
    }

    if (state.selectedNavId == "analytics-reports" && (state.roleCode == SchoolKeys.V_ROLE_TEACHER || state.roleCode == SchoolKeys.V_ROLE_SCHOOL_ADMIN)) {
        Column(modifier = modifier.fillMaxSize().padding(horizontal = 24.dp, vertical = 20.dp)) {
            Box(Modifier.fillMaxWidth().widthIn(max = contentWidth).align(Alignment.CenterHorizontally)) {
                HomeHeader(state, onEvent, onLogout, onEditProfile)
            }
            Spacer(Modifier.height(14.dp))
            StaffPerformanceReportsScreen(
                isTeacher = state.roleCode == SchoolKeys.V_ROLE_TEACHER,
                schoolId = state.schoolId,
                activeAcademicYearId = state.activeAcademicYearId,
                modifier = Modifier.fillMaxWidth().widthIn(max = contentWidth).align(Alignment.CenterHorizontally).weight(1f)
            )
        }
        return
    }

    val scrollState = rememberScrollState()
    Column(
        modifier = modifier
            .fillMaxSize()
            .padding(horizontal = 24.dp, vertical = 20.dp),
    ) {
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .widthIn(max = contentWidth)
                .align(Alignment.CenterHorizontally)
        ) {
                HomeHeader(
                    state = state,
                    onEvent = onEvent,
                    onLogout = onLogout,
                    onEditProfile = onEditProfile
                )
        }

        Spacer(modifier = Modifier.height(14.dp))

        BoxWithConstraints(
            modifier = Modifier
                .fillMaxWidth()
                .widthIn(max = contentWidth)
                .align(Alignment.CenterHorizontally)
                .weight(1f)
        ) {
            val teacherDesktopLayout = state.roleCode == SchoolKeys.V_ROLE_TEACHER && maxWidth >= 820.dp
            val parentDesktopLayout = state.roleCode == SchoolKeys.V_ROLE_PARENT && maxWidth >= 980.dp

            if (teacherDesktopLayout) {
                Column(modifier = Modifier.fillMaxSize()) {
                    TeacherDashboardCards(state.teacherDashboard, state.isTeacherDashboardLoading, Modifier.fillMaxWidth().weight(1f)) { navId -> onEvent(HomeUiEvent.NavSelected(navId)) }
                }
            } else if (parentDesktopLayout) {
                var selectedChildIndex by remember { mutableStateOf(0) }
                val parentChildren = parentChildren(state)
                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .verticalScroll(scrollState)
                ) {
                    ParentAnnouncementPager(state.activeAnnouncements)
                    Spacer(modifier = Modifier.height(18.dp))
                    if (state.isParentDashboardLoading || state.isParentProfileLoading) ParentHomeShimmer()
                    else if (parentChildren.isNotEmpty()) ParentStudentCard(
                        selectedChild = parentChildren[selectedChildIndex.coerceIn(parentChildren.indices)],
                        children = parentChildren,
                        onChildSelected = { selectedChildIndex = it },
                        modifier = Modifier.fillMaxWidth()
                    ) else ParentNoChildrenCard()
                    Spacer(modifier = Modifier.height(18.dp))
                    ParentDashboardCards(
                        dashboard = state.parentDashboard,
                        onNavigate = { navId -> onEvent(HomeUiEvent.NavSelected(navId)) },
                        modifier = Modifier.fillMaxWidth()
                    )
                }
            } else {
                Column(
                    modifier = Modifier
                        .fillMaxSize()
                        .verticalScroll(scrollState),
                    verticalArrangement = Arrangement.spacedBy(18.dp)
                ) {
                    if (state.roleCode == SchoolKeys.V_ROLE_TEACHER) {
                        TeacherDashboardCards(state.teacherDashboard, state.isTeacherDashboardLoading) { navId -> onEvent(HomeUiEvent.NavSelected(navId)) }
                    } else if (state.roleCode == SchoolKeys.V_ROLE_PARENT) {
                        var selectedChildIndex by remember { mutableStateOf(0) }
                        val parentChildren = parentChildren(state)
                        ParentAnnouncementPager(state.activeAnnouncements)
                        if (state.isParentDashboardLoading || state.isParentProfileLoading) ParentHomeShimmer()
                        else if (parentChildren.isNotEmpty()) ParentStudentCard(
                            selectedChild = parentChildren[selectedChildIndex.coerceIn(parentChildren.indices)],
                            children = parentChildren,
                            onChildSelected = { selectedChildIndex = it }
                        ) else ParentNoChildrenCard()
                        ParentDashboardCards(
                            dashboard = state.parentDashboard,
                            onNavigate = { navId -> onEvent(HomeUiEvent.NavSelected(navId)) }
                        )
                    } else {
                        Box(modifier = Modifier.fillMaxWidth()) {
                            if (state.isDashboardLoading) {
                                MetricGridShimmer(
                                    columns = metricColumns,
                                    itemCount = expectedDashboardMetricCount(state.roleCode)
                                )
                            } else if (content.metrics.isEmpty()) {
                                DashboardSurface(modifier = Modifier.fillMaxWidth()) {
                                    Box(
                                        modifier = Modifier
                                            .fillMaxWidth()
                                            .padding(horizontal = 24.dp, vertical = 28.dp),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        AdminListEmptyState(
                                            title = "Dashboard data unavailable",
                                            subtitle = "We could not load platform metrics right now."
                                        )
                                    }
                                }
                            } else {
                                MetricGrid(
                                    metrics = content.metrics,
                                    columns = metricColumns
                                )
                            }
                        }

                        Box(modifier = Modifier.fillMaxWidth()) {
                            ActivityAndHealthSection(
                                recentActivities = content.recentActivities,
                                healthEntries = content.healthEntries,
                                isLoading = state.isDashboardFeedLoading,
                                hasHealthData = state.systemHealth != null
                            )
                        }
                    }
                }
            }
        }

    }
}

private data class ParentDemoChild(val initials: String, val name: String, val classLabel: String, val school: String, val rollNumber: String, val admissionNumber: String, val teacher: String)

private fun parentLinkedChildren(state: HomeUiState): List<com.schoolconnect.app.feature.attendance.ParentAttendanceChild> {
    val dashboardByStudentId = state.parentDashboard?.children.orEmpty()
        .mapNotNull { child -> child.studentId?.trim()?.takeIf(String::isNotBlank)?.let { it to child } }
        .toMap()
    val profileChildren = state.parentProfile?.students.orEmpty().mapNotNull { student ->
        val id = student.studentId?.trim().orEmpty()
        id.takeIf { it.isNotBlank() }?.let {
            val dashboardChild = dashboardByStudentId[it]
            com.schoolconnect.app.feature.attendance.ParentAttendanceChild(
                id = it,
                name = student.studentName.orEmpty().ifBlank { dashboardChild?.studentName.orEmpty().ifBlank { "Student" } },
                rollNumber = dashboardChild?.rollNumber.orEmpty().ifBlank { "—" },
                classLabel = listOfNotNull(student.className, student.sectionName).joinToString("-").ifBlank { "—" }
            )
        }
    }
    return profileChildren.ifEmpty {
        state.parentDashboard?.children.orEmpty().mapNotNull { child ->
            val id = child.studentId?.trim().orEmpty()
            id.takeIf { it.isNotBlank() }?.let {
                com.schoolconnect.app.feature.attendance.ParentAttendanceChild(
                    id = it,
                    name = child.studentName.orEmpty().ifBlank { "Student" },
                    rollNumber = child.rollNumber.orEmpty().ifBlank { "—" },
                    classLabel = "—"
                )
            }
        }
    }
}

private fun parentChildren(state: HomeUiState): List<ParentDemoChild> {
    val dashboardByStudentId = state.parentDashboard?.children.orEmpty()
        .mapNotNull { child -> child.studentId?.trim()?.takeIf(String::isNotBlank)?.let { it to child } }
        .toMap()
    val wardsByStudentId = state.parentWards.mapNotNull { ward ->
        ward.id?.trim()?.takeIf(String::isNotBlank)?.let { it to ward }
    }.toMap()
    return state.parentProfile?.students.orEmpty().mapNotNull { student ->
        val id = student.studentId?.trim().orEmpty()
        id.takeIf { it.isNotBlank() }?.let {
            val name = student.studentName.orEmpty().ifBlank { "Student" }
            val ward = wardsByStudentId[it]
            val dashboardChild = dashboardByStudentId[it]
            ParentDemoChild(
                initials = name.split(" ").filter(String::isNotBlank).take(2).joinToString("") { it.first().uppercase() },
                name = name,
                classLabel = listOfNotNull(
                    ward?.className ?: student.className,
                    ward?.sectionName ?: student.sectionName
                ).joinToString("-").ifBlank { "—" },
                school = state.schoolLabel,
                rollNumber = ward?.rollNumber ?: dashboardChild?.rollNumber.orEmpty().ifBlank { "—" },
                admissionNumber = ward?.admissionNumber ?: student.admissionNumber.orEmpty().ifBlank { "—" },
                teacher = "—"
            )
        }
    }
}

private val ParentAnnouncementSurface = Color(0xFFFFFBEB)
private val ParentAnnouncementBorder = Color(0xFFF6B83F)
private val ParentAnnouncementIconSurface = Color(0xFFFFF1C2)
private val ParentAnnouncementText = Color(0xFFB45309)

@Composable
private fun ParentAnnouncementPager(
    announcements: List<com.schoolconnect.app.datasource.network.response.QuickAnnouncementResponse>,
    modifier: Modifier = Modifier
) {
    val visibleAnnouncements = announcements.filter { !it.message.isNullOrBlank() }
    if (visibleAnnouncements.isEmpty()) return
    val pagerState = rememberPagerState(pageCount = { visibleAnnouncements.size })
    val pagerScope = rememberCoroutineScope()
    LaunchedEffect(visibleAnnouncements.size) {
        if (visibleAnnouncements.size > 1) {
            while (true) {
                delay(5000)
                pagerState.animateScrollToPage((pagerState.currentPage + 1) % visibleAnnouncements.size)
            }
        }
    }
    Card(
        modifier = modifier.fillMaxWidth(),
        shape = RoundedCornerShape(12.dp),
        colors = CardDefaults.cardColors(containerColor = ParentAnnouncementSurface),
        border = androidx.compose.foundation.BorderStroke(1.dp, ParentAnnouncementBorder),
        elevation = CardDefaults.cardElevation(defaultElevation = 1.dp)
    ) {
        HorizontalPager(state = pagerState, modifier = Modifier.fillMaxWidth()) { page ->
            val announcement = visibleAnnouncements[page]
            Row(
                Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(12.dp))
                    .background(ParentAnnouncementSurface)
                    .padding(horizontal = 16.dp, vertical = 10.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(14.dp)
            ) {
            Box(
                Modifier.size(44.dp).background(ParentAnnouncementIconSurface, CircleShape),
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    painter = homeIconPainter("megaphone"),
                    contentDescription = "Announcement",
                    tint = ParentAnnouncementText,
                    modifier = Modifier.size(24.dp)
                )
            }
            Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(4.dp)) {
                Text("Quick Announcement", style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = ParentAnnouncementText)
                Text(announcement.message.orEmpty(), style = MaterialTheme.typography.bodyMedium, color = HomeTextPrimary, maxLines = 2, overflow = TextOverflow.Ellipsis)
            }
            announcement.displayUntil?.takeIf { it.isNotBlank() }?.let { Text("Until ${dashboardDateLabel(it)}", style = MaterialTheme.typography.bodySmall, color = HomeTextSecondary, maxLines = 1) }
            }
        }
        if (visibleAnnouncements.size > 1) {
            Row(
                modifier = Modifier.fillMaxWidth().padding(horizontal = 12.dp, vertical = 4.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                IconButton(
                    onClick = {
                        pagerScope.launch {
                            val previous = (pagerState.currentPage - 1 + visibleAnnouncements.size) % visibleAnnouncements.size
                            pagerState.animateScrollToPage(previous)
                        }
                    },
                    modifier = Modifier.size(32.dp)
                ) {
                    Icon(painter = homeIconPainter("arrow_left"), contentDescription = "Previous announcement", tint = ParentAnnouncementText)
                }
                Text(
                    "${pagerState.currentPage + 1} of ${visibleAnnouncements.size}",
                    style = MaterialTheme.typography.labelMedium,
                    fontWeight = FontWeight.Bold,
                    color = ParentAnnouncementText
                )
                Row(
                    modifier = Modifier.weight(1f),
                    horizontalArrangement = Arrangement.Center,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    visibleAnnouncements.indices.forEach { index ->
                        Box(
                            modifier = Modifier
                                .padding(horizontal = 3.dp)
                                .size(if (index == pagerState.currentPage) 8.dp else 6.dp)
                                .background(
                                    if (index == pagerState.currentPage) ParentAnnouncementText else ParentAnnouncementBorder,
                                    CircleShape
                                )
                                .clickable {
                                    pagerScope.launch { pagerState.animateScrollToPage(index) }
                                }
                        )
                    }
                }
                IconButton(
                    onClick = {
                        pagerScope.launch {
                            pagerState.animateScrollToPage((pagerState.currentPage + 1) % visibleAnnouncements.size)
                        }
                    },
                    modifier = Modifier.size(32.dp)
                ) {
                    Icon(painter = homeIconPainter("arrow_right"), contentDescription = "Next announcement", tint = ParentAnnouncementText)
                }
            }
        }
    }
}

@Composable
private fun ParentNoChildrenCard() {
    DashboardSurface(Modifier.fillMaxWidth()) {
        Column(Modifier.fillMaxWidth().padding(28.dp), horizontalAlignment = Alignment.CenterHorizontally) {
            Text("No linked children found", fontWeight = FontWeight.Bold, color = HomeTextPrimary)
            Text("Your linked student records will appear here.", color = HomeTextSecondary)
        }
    }
}

@Composable
private fun ParentHomeShimmer() {
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(16.dp)) {
        ProfileCardShimmer()
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(16.dp)) {
            repeat(4) { index ->
                ParentShimmerBlock(Modifier.weight(1f).height(if (index == 0) 116.dp else 116.dp))
            }
        }
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(16.dp)) {
            repeat(3) { ParentShimmerBlock(Modifier.weight(1f).height(240.dp)) }
        }
    }
}

@Composable
private fun ParentShimmerBlock(modifier: Modifier) {
    val transition = rememberInfiniteTransition(label = "parent_home_shimmer")
    val x by transition.animateFloat(
        initialValue = -300f,
        targetValue = 900f,
        animationSpec = infiniteRepeatable(tween(1200, easing = LinearEasing), RepeatMode.Restart),
        label = "parent_home_shimmer_x"
    )
    DashboardSurface(modifier) {
        Box(Modifier.fillMaxSize().background(Brush.linearGradient(listOf(Color(0xFFE4EAF7), Color(0xFFF9FBFF), Color(0xFFE4EAF7)), Offset(x, x), Offset(x + 220f, x + 220f))))
    }
}

private fun Double.displayPercentage(): String = if (this % 1.0 == 0.0) toInt().toString() else toString()

/* private legacy helper retained only for source compatibility.
private fun kotlinx.serialization.json.JsonObject?.parentMetric(
    primary: String,
    alternate: String,
    fallback: String,
    suffix: String = ""
): String {
    val value = this?.get(primary)?.toString()?.trim('"')?.takeIf { it.isNotBlank() }
        ?: this?.get(alternate)?.toString()?.trim('"')?.takeIf { it.isNotBlank() }
        ?: fallback
    return if (suffix.isNotEmpty() && value != fallback && !value.endsWith(suffix)) "$value$suffix" else value
}
*/

@Composable
private fun ParentStudentCard(selectedChild: ParentDemoChild, children: List<ParentDemoChild>, onChildSelected: (Int) -> Unit, modifier: Modifier = Modifier) {
    DashboardSurface(modifier = modifier) {
        ParentStudentDetails(selectedChild, Modifier.fillMaxWidth().padding(horizontal = 22.dp, vertical = 18.dp))
    }
}

@Composable
private fun ParentStudentDetails(child: ParentDemoChild, modifier: Modifier = Modifier) {
    Row(modifier, verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(18.dp)) {
        AvatarChip(initials = child.initials, modifier = Modifier.size(92.dp))
        Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Text(child.name, style = MaterialTheme.typography.headlineSmall, fontWeight = FontWeight.Bold, color = HomeTextPrimary)
            Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                Text("Class : ${child.classLabel}", style = MaterialTheme.typography.bodyMedium, color = HomeTextPrimary)
                Text("|", color = HomeBorder)
                Text("Roll No : ${child.rollNumber}", style = MaterialTheme.typography.bodyMedium, color = HomeTextPrimary)
                Text("|", color = HomeBorder)
                Text("Admission No : ${child.admissionNumber}", style = MaterialTheme.typography.bodyMedium, color = HomeTextPrimary)
            }
            Row(horizontalArrangement = Arrangement.spacedBy(18.dp)) {
                ParentMetaItem("teacher", "Class Teacher : ${child.teacher}")
            }
        }
    }
}

@Composable
private fun ParentMetaItem(icon: String, text: String) {
    Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
        Icon(painter = homeIconPainter(icon), contentDescription = null, tint = HomeTextPrimary, modifier = Modifier.size(18.dp))
        Text(text, style = MaterialTheme.typography.bodyMedium, color = HomeTextPrimary)
    }
}

@Composable
private fun ParentChildrenSelector(selectedChild: ParentDemoChild, children: List<ParentDemoChild>, onChildSelected: (Int) -> Unit, modifier: Modifier = Modifier) {
    var expanded by remember { mutableStateOf(false) }
    Box(modifier) {
        Row(
            Modifier
                .clip(RoundedCornerShape(12.dp))
                .background(if (expanded) HomeBlueSoft.copy(alpha = 0.7f) else Color.White)
                .border(1.dp, if (expanded) HomeBlue else HomeBorder, RoundedCornerShape(12.dp))
                .clickable { expanded = true }
                .padding(horizontal = 12.dp, vertical = 10.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            AvatarChip(initials = selectedChild.initials, modifier = Modifier.size(38.dp))
            Column(Modifier.weight(1f)) {
                Text("Current child", style = MaterialTheme.typography.labelSmall, color = HomeTextSecondary)
                Text("${selectedChild.name} · ${selectedChild.classLabel}", style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = HomeTextPrimary, maxLines = 1, overflow = TextOverflow.Ellipsis)
            }
            Box(Modifier.size(28.dp).background(HomeBlueSoft, CircleShape), contentAlignment = Alignment.Center) {
                Icon(painter = homeIconPainter(if (expanded) "chevron_up" else "chevron_down"), contentDescription = "Select child", tint = HomeBlue, modifier = Modifier.size(18.dp))
            }
        }

        AppDropdownMenu(
            expanded = expanded,
            onDismissRequest = { expanded = false },
            width = 300.dp,
            containerColor = Color.White,
            shape = RoundedCornerShape(14.dp),
            border = androidx.compose.foundation.BorderStroke(1.dp, HomeBorder),
            shadowElevation = 14.dp
        ) {
            Column(Modifier.padding(vertical = 8.dp)) {
                Row(Modifier.fillMaxWidth().padding(horizontal = 14.dp, vertical = 8.dp), verticalAlignment = Alignment.CenterVertically) {
                    Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
                        Text("My Children", style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = HomeTextPrimary)
                    Text("Select a child to view their dashboard", style = MaterialTheme.typography.labelSmall, color = HomeTextSecondary)
                    }
                }
                HorizontalDivider(color = HomeBorder)
                children.forEachIndexed { index, child ->
                    Row(
                        Modifier.fillMaxWidth().background(if (child == selectedChild) HomeBlueSoft else Color.Transparent, RoundedCornerShape(12.dp)).clickable { expanded = false; onChildSelected(index) }.padding(10.dp),
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(10.dp)
                    ) {
                        AvatarChip(initials = child.initials, modifier = Modifier.size(38.dp))
                        Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
                            Text("${child.name} (${child.classLabel})", style = MaterialTheme.typography.bodySmall, fontWeight = FontWeight.Bold, color = HomeTextPrimary)
                            Text("${child.school} · Class ${child.classLabel}", style = MaterialTheme.typography.labelSmall, color = HomeTextSecondary)
                        }
                        if (child == selectedChild) {
                            Text("Selected", style = MaterialTheme.typography.labelSmall, fontWeight = FontWeight.Bold, color = HomeBlue)
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun ParentDashboardCards(
    dashboard: com.schoolconnect.app.datasource.network.response.ParentDashboardResponse?,
    onNavigate: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    BoxWithConstraints(modifier = modifier.fillMaxWidth()) {
        val wide = maxWidth >= 980.dp
        Column(
            Modifier.fillMaxWidth(),
            verticalArrangement = Arrangement.spacedBy(16.dp)
        ) {
            ParentAnalyticsCards(dashboard, onNavigate)
            if (wide) {
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                    val cardModifier = Modifier.weight(1f).height(320.dp)
                    ParentNoticesCard(dashboard, onNavigate, cardModifier)
                    ParentHomeworkCard(dashboard, onNavigate, cardModifier)
                    ParentEventsCard(dashboard, onNavigate, cardModifier)
                }
            } else {
                ParentNoticesCard(dashboard, onNavigate)
                ParentHomeworkCard(dashboard, onNavigate)
                ParentEventsCard(dashboard, onNavigate)
            }
        }
    }
}

@Composable
private fun ParentAnalyticsCards(
    dashboard: com.schoolconnect.app.datasource.network.response.ParentDashboardResponse?,
    onNavigate: (String) -> Unit
) {
    val analytics = listOf(
        listOf("megaphone", "New Notices", dashboard?.statistics?.newNoticesCount?.toString() ?: "—", "Unread", "View All", HomePurple, HomePurpleSoft, "notices"),
        listOf("document", "Teacher Notes", dashboard?.statistics?.newTeacherNotesCount?.toString() ?: "—", "New Notes", "View All", HomeOrange, HomeOrangeSoft, "parent-notes"),
        listOf("calendar", "Attendance", dashboard?.statistics?.attendancePercentage?.let { "${it.displayPercentage()}%" } ?: "—", dashboard?.statistics?.let { "${it.attendancePresentDays ?: 0} / ${it.attendanceTotalDays ?: 0} Days" } ?: "—", "View Details", HomeGreen, HomeGreenSoft, "attendance"),
        listOf("graduation_cap", "Exam Results", dashboard?.statistics?.examResultPercentage?.let { "${it.displayPercentage()}%" } ?: "—", "Latest average", "View Results", HomeBlue, HomeBlueSoft, "exam-results")
    )
    BoxWithConstraints(Modifier.fillMaxWidth()) {
        if (maxWidth >= 1120.dp) {
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                analytics.forEach { item -> ParentAnalyticsCard(item, onNavigate, Modifier.weight(1f)) }
            }
        } else {
            Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                analytics.chunked(2).forEach { row ->
                    Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(16.dp)) {
                        row.forEach { item -> ParentAnalyticsCard(item, onNavigate, Modifier.weight(1f)) }
                    }
                }
            }
        }
    }
}

@Composable
private fun ParentAnalyticsCard(item: List<Any>, onNavigate: (String) -> Unit, modifier: Modifier = Modifier) {
    DashboardSurface(modifier = modifier) {
        Column(Modifier.fillMaxWidth().padding(18.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(14.dp)) {
                Box(Modifier.size(64.dp).background(item[6] as Color, RoundedCornerShape(14.dp)), contentAlignment = Alignment.Center) {
                    Icon(painter = homeIconPainter(item[0] as String), contentDescription = null, tint = item[5] as Color, modifier = Modifier.size(32.dp))
                }
                Column(verticalArrangement = Arrangement.spacedBy(3.dp)) {
                    Text(item[1] as String, style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = HomeTextPrimary)
                    Text(item[2] as String, style = MaterialTheme.typography.headlineSmall, fontWeight = FontWeight.Bold, color = HomeTextPrimary)
                    Text(item[3] as String, style = MaterialTheme.typography.bodySmall, color = HomeTextPrimary)
                }
            }
            Spacer(Modifier.height(12.dp))
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.End, verticalAlignment = Alignment.CenterVertically) {
                Text(
                    item[4] as String,
                    style = MaterialTheme.typography.bodySmall,
                    fontWeight = FontWeight.Bold,
                    color = HomeBlue,
                    modifier = Modifier.clickable { onNavigate(item[7] as String) }
                )
                Spacer(Modifier.width(6.dp))
                Icon(painter = homeIconPainter("arrow_right"), contentDescription = null, tint = HomeBlue, modifier = Modifier.size(18.dp))
            }
        }
    }
}

@Composable
private fun ParentNoticesCard(
    dashboard: com.schoolconnect.app.datasource.network.response.ParentDashboardResponse?,
    onNavigate: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    ParentListCard(modifier, "megaphone", "Recent Notices", "View All", onAction = { onNavigate("notices") }) {
        val notices = dashboard?.notices.orEmpty().filter { !it.title.isNullOrBlank() }
        if (notices.isEmpty()) {
            ParentFeedEmptyState("No recent notices")
        } else {
            notices.take(4).forEach { notice ->
                ParentListRow(notice.title.orEmpty(), dashboardDateLabel(notice.createdAt))
            }
        }
    }
}

@Composable
private fun ParentHomeworkCard(
    dashboard: com.schoolconnect.app.datasource.network.response.ParentDashboardResponse?,
    onNavigate: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    ParentListCard(modifier, "book", "Homework", "View All", onAction = { onNavigate("homework") }) {
        val homework = dashboard?.homework.orEmpty().filter { !it.title.isNullOrBlank() }
        if (homework.isEmpty()) {
            ParentFeedEmptyState("No homework")
        } else {
            homework.take(4).forEach { item ->
                ParentListRow(
                    item.title.orEmpty(),
                    item.dueDate?.let(::dashboardDateLabel) ?: item.status.orEmpty().ifBlank { "—" },
                    HomeOrange
                )
            }
        }
    }
}

@Composable
private fun ParentEventsCard(
    dashboard: com.schoolconnect.app.datasource.network.response.ParentDashboardResponse?,
    onNavigate: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    ParentListCard(modifier, "calendar", "Upcoming Events", "View Events", onAction = { onNavigate("events-news") }) {
        val events = dashboard?.events.orEmpty().filter { !it.title.isNullOrBlank() }
        if (events.isEmpty()) {
            ParentFeedEmptyState("No upcoming events")
        } else {
            events.take(4).forEach { event ->
                ParentListRow(event.title.orEmpty(), dashboardDateLabel(event.eventDate), HomeBlue)
            }
        }
    }
}

@Composable
private fun ParentFeedEmptyState(message: String) {
    Text(
        message,
        style = MaterialTheme.typography.bodyMedium,
        color = HomeTextSecondary,
        modifier = Modifier.padding(vertical = 18.dp)
    )
}

@Composable
private fun ParentListCard(
    modifier: Modifier,
    icon: String,
    title: String,
    action: String,
    onAction: () -> Unit,
    content: @Composable ColumnScope.() -> Unit
) {
    DashboardSurface(modifier = modifier) {
        ParentCardHeader(icon, title, action, onAction)
        Column(Modifier.padding(horizontal = 18.dp, vertical = 4.dp), content = content)
    }
}

@Composable
private fun ParentCardHeader(icon: String, title: String, action: String, onAction: () -> Unit) {
    Row(
        Modifier.fillMaxWidth().padding(horizontal = 18.dp, vertical = 16.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(painter = homeIconPainter(icon), contentDescription = null, tint = HomePurple, modifier = Modifier.size(24.dp))
        Spacer(Modifier.width(10.dp))
        Text(title, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = HomeTextPrimary, modifier = Modifier.weight(1f))
        Text(
            action,
            style = MaterialTheme.typography.bodySmall,
            fontWeight = FontWeight.Bold,
            color = HomeBlue,
            modifier = Modifier.clickable(onClick = onAction)
        )
    }
}

@Composable
private fun ParentChildRow(initials: String, name: String, classLabel: String, school: String, selected: Boolean = false) {
    Row(
        Modifier.fillMaxWidth().background(if (selected) HomeBlueSoft else Color.Transparent, RoundedCornerShape(12.dp)).padding(10.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(10.dp)
    ) {
        AvatarChip(initials = initials, modifier = Modifier.size(38.dp))
        Column(Modifier.weight(1f)) {
            Text("$name ($classLabel)", style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.Bold, color = HomeTextPrimary)
            Text(school, style = MaterialTheme.typography.bodySmall, color = HomeTextSecondary)
        }
    }
}

@Composable
private fun ParentStat(value: String, label: String, tint: Color, background: Color, modifier: Modifier = Modifier) {
    Column(modifier.background(background, RoundedCornerShape(14.dp)).padding(14.dp), verticalArrangement = Arrangement.spacedBy(4.dp)) {
        Text(value, style = MaterialTheme.typography.headlineSmall, fontWeight = FontWeight.Bold, color = tint)
        Text(label, style = MaterialTheme.typography.bodySmall, color = HomeTextPrimary)
    }
}

@Composable
private fun ColumnScope.ParentListRow(title: String, trailing: String, tint: Color = HomeTextPrimary) {
    Row(Modifier.fillMaxWidth().padding(vertical = 11.dp), verticalAlignment = Alignment.CenterVertically) {
        Text(title, style = MaterialTheme.typography.bodySmall, color = HomeTextPrimary, modifier = Modifier.weight(1f), maxLines = 1, overflow = TextOverflow.Ellipsis)
        Text(trailing, style = MaterialTheme.typography.bodySmall, color = tint, fontWeight = FontWeight.SemiBold)
    }
    HorizontalDivider(color = HomeBorder)
}

@Composable
private fun TeacherDashboardCards(
    overview: TeacherDashboardOverviewResponse?,
    isLoading: Boolean,
    modifier: Modifier = Modifier,
    onNavigate: (String) -> Unit = {}
) {
    BoxWithConstraints(modifier = modifier.fillMaxWidth()) {
        val twoColumns = maxWidth >= 820.dp
        // Compact dashboards are inside a verticalScroll, so their height is
        // unbounded. Never derive a child height from Dp.Infinity.
        val cardHeight = if (maxHeight != Dp.Infinity) {
            ((maxHeight - 16.dp) / 2f).coerceAtLeast(240.dp)
        } else {
            280.dp
        }
        if (twoColumns) {
            Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(16.dp)
                ) {
                    TeacherClassesCard(overview, isLoading, Modifier.weight(1f).height(cardHeight))
                    TeacherStudentsCard(overview, isLoading, Modifier.weight(1f).height(cardHeight))
                }
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.spacedBy(16.dp)
                ) {
                    TeacherNoticesCard(overview, isLoading, Modifier.weight(1f).height(cardHeight), onNavigate)
                    TeacherEventsCard(overview, isLoading, Modifier.weight(1f).height(cardHeight), onNavigate)
                }
            }
        } else {
            Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                TeacherClassesCard(overview, isLoading, Modifier.fillMaxWidth().height(cardHeight))
                TeacherStudentsCard(overview, isLoading, Modifier.fillMaxWidth().height(cardHeight))
                TeacherNoticesCard(overview, isLoading, Modifier.fillMaxWidth().height(cardHeight), onNavigate)
                TeacherEventsCard(overview, isLoading, Modifier.fillMaxWidth().height(cardHeight), onNavigate)
            }
        }
    }
}

@Composable
private fun TeacherClassesCard(
    overview: TeacherDashboardOverviewResponse?,
    isLoading: Boolean,
    modifier: Modifier = Modifier
) {
    if (isLoading || overview == null) {
        TeacherDashboardCardShimmer(modifier)
        return
    }
    val assignedClasses = overview.myClasses
        .groupBy { item ->
            item.classSectionId?.takeIf(String::isNotBlank)
                ?: "${item.className.orEmpty()}-${item.sectionName.orEmpty()}"
        }
        .map { (classId, assignments) ->
            val classInfo = assignments.first()
            val className = listOfNotNull(classInfo.className, classInfo.sectionName)
                .joinToString("-")
                .ifBlank { "—" }
            val roleLabels = assignments.mapNotNull { it.roleType?.trim()?.takeIf(String::isNotBlank) }
                .distinct()
            val subjectLabels = assignments.mapNotNull { it.subjectName?.trim()?.takeIf(String::isNotBlank) }
                .distinct()
            TeacherDashboardClassRow(
                key = classId,
                className = className,
                roleLabel = roleLabels.joinToString(", ").ifBlank { "—" },
                subjectsLabel = subjectLabels.joinToString(", ").ifBlank { "—" }
            )
        }
        .sortedWith { left, right -> compareSmartText(left.className, right.className) }

    TeacherDashboardCard(modifier = modifier) {
        TeacherCardHeader(
            icon = "open_book",
            iconTint = HomeBlue,
            iconBackground = HomeBlueSoft,
            title = "My Classes",
            subtitle = "${assignedClasses.size} Assigned Classes"
        )
        TeacherClassTableHeader()
        if (assignedClasses.isEmpty()) {
            Box(
                modifier = Modifier.fillMaxWidth().weight(1f),
                contentAlignment = Alignment.Center
            ) {
                AdminListEmptyState(
                    title = "No classes assigned",
                    subtitle = "There is no class data to display yet."
                )
            }
        } else {
            DesktopAwareLazyColumn(
                modifier = Modifier.fillMaxWidth().weight(1f),
                contentPadding = PaddingValues(end = 22.dp)
            ) {
                assignedClasses.forEach { classRow ->
                    item(key = "class-${classRow.key}") {
                        TeacherClassTableRow(classRow)
                    }
                }
            }
        }
    }
}

private data class TeacherDashboardClassRow(
    val key: String,
    val className: String,
    val roleLabel: String,
    val subjectsLabel: String
)

@Composable
private fun TeacherClassTableHeader() {
    Row(
        modifier = Modifier.fillMaxWidth().padding(start = 32.dp, end = 22.dp).padding(horizontal = 8.dp, vertical = 10.dp),
        horizontalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        Text(
            text = "Class",
            modifier = Modifier.weight(0.8f),
            style = MaterialTheme.typography.bodyMedium,
            fontWeight = FontWeight.Bold,
            color = HomeTextPrimary
        )
        Text("Role", modifier = Modifier.weight(1.0f), style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.Bold, color = HomeTextPrimary)
        Text("Subjects", modifier = Modifier.weight(1.1f), style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.Bold, color = HomeTextPrimary)
    }
    HorizontalDivider(modifier = Modifier.padding(start = 32.dp, end = 22.dp), color = HomeBorder)
}

@Composable
private fun TeacherClassTableRow(classRow: TeacherDashboardClassRow) {
    Row(
        modifier = Modifier.fillMaxWidth().padding(start = 32.dp).padding(horizontal = 8.dp, vertical = 11.dp),
        horizontalArrangement = Arrangement.spacedBy(12.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Text(
            text = classRow.className,
            modifier = Modifier.weight(0.8f),
            style = MaterialTheme.typography.bodyMedium,
            fontWeight = FontWeight.SemiBold,
            color = HomeBlue,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        Text(classRow.roleLabel, modifier = Modifier.weight(1.0f), style = MaterialTheme.typography.bodyMedium, color = HomeTextPrimary, maxLines = 2, overflow = TextOverflow.Ellipsis)
        Text(classRow.subjectsLabel, modifier = Modifier.weight(1.1f), style = MaterialTheme.typography.bodyMedium, color = HomeTextPrimary, maxLines = 2, overflow = TextOverflow.Ellipsis)
    }
    HorizontalDivider(modifier = Modifier.padding(start = 32.dp), color = HomeBorder)
}

@Composable
private fun TeacherStudentsCard(
    overview: TeacherDashboardOverviewResponse?,
    isLoading: Boolean,
    modifier: Modifier = Modifier
) {
    if (isLoading || overview == null) {
        TeacherStudentsCardShimmer(modifier)
        return
    }
    TeacherDashboardCard(modifier = modifier) {
        TeacherCardHeader(
            icon = "graduation_cap",
            iconTint = HomeGreen,
            iconBackground = HomeGreenSoft,
            title = "My Students",
            subtitle = "${overview.totalStudents ?: 0} Students"
        )
        if ((overview.totalStudents ?: 0) <= 0) {
            Box(
                modifier = Modifier.fillMaxWidth().weight(1f),
                contentAlignment = Alignment.Center
            ) {
                AdminListEmptyState(
                    title = "No students assigned",
                    subtitle = "There is no student data to display yet."
                )
            }
        } else {
            val studentClassRows = overview.myClasses
                .groupBy { item ->
                    item.classSectionId?.takeIf(String::isNotBlank)
                        ?: "${item.className.orEmpty()}-${item.sectionName.orEmpty()}"
                }
                .map { (classId, assignments) ->
                    val classInfo = assignments.first()
                    classId to listOf(
                        listOfNotNull(classInfo.className, classInfo.sectionName).joinToString("-").ifBlank { "—" },
                        classInfo.boysCount?.toString() ?: "—",
                        classInfo.girlsCount?.toString() ?: "—",
                        classInfo.totalStudents?.toString() ?: "—"
                    )
                }
                .sortedWith { left, right -> compareSmartText(left.second.first(), right.second.first()) }
            TeacherTableHeader(labels = listOf("Class", "Boys", "Girls", "Total"))
            DesktopAwareLazyColumn(
                modifier = Modifier.fillMaxWidth().weight(1f),
                contentPadding = PaddingValues(end = 22.dp)
            ) {
                studentClassRows.forEach { (classId, values) ->
                    item(key = "students-class-$classId") {
                        TeacherTableRow(values = values, firstValueTint = HomeBlue, lastValueTint = HomeGreen)
                    }
                }
            }
        }
    }
}

@Composable
private fun TeacherStudentsCardShimmer(modifier: Modifier = Modifier) {
    val transition = rememberInfiniteTransition(label = "teacher_students_card_shimmer")
    val shimmerX by transition.animateFloat(
        initialValue = -320f,
        targetValue = 960f,
        animationSpec = infiniteRepeatable(tween(1200, easing = LinearEasing), RepeatMode.Restart),
        label = "teacher_students_card_shimmer_x"
    )
    val shimmerBrush = Brush.linearGradient(
        colors = listOf(HomeBorder.copy(alpha = .45f), Color.White, HomeBorder.copy(alpha = .45f)),
        start = Offset(shimmerX, 0f),
        end = Offset(shimmerX + 260f, 0f)
    )

    TeacherDashboardCard(modifier = modifier) {
        Row(horizontalArrangement = Arrangement.spacedBy(14.dp), verticalAlignment = Alignment.CenterVertically) {
            Box(Modifier.size(54.dp).background(shimmerBrush, RoundedCornerShape(16.dp)))
            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                Box(Modifier.width(150.dp).height(20.dp).background(shimmerBrush, RoundedCornerShape(8.dp)))
                Box(Modifier.width(110.dp).height(14.dp).background(shimmerBrush, RoundedCornerShape(8.dp)))
            }
        }
        Spacer(Modifier.height(18.dp))
        Box(Modifier.fillMaxWidth().height(14.dp).background(shimmerBrush, RoundedCornerShape(6.dp)))
        Spacer(Modifier.height(12.dp))
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Box(Modifier.width(150.dp).height(16.dp).background(shimmerBrush, RoundedCornerShape(6.dp)))
            Box(Modifier.width(42.dp).height(18.dp).background(shimmerBrush, RoundedCornerShape(6.dp)))
        }
    }
}

@Composable
private fun TeacherNoticesCard(
    overview: TeacherDashboardOverviewResponse?,
    isLoading: Boolean,
    modifier: Modifier = Modifier,
    onNavigate: (String) -> Unit = {}
) {
    if (isLoading || overview == null) {
        TeacherDashboardCardShimmer(modifier)
        return
    }
    TeacherDashboardCard(modifier = modifier) {
        TeacherCardHeader(
            icon = "megaphone",
            iconTint = HomePurple,
            iconBackground = HomePurpleSoft,
            title = "Recent Notices",
            actionLabel = "View Notices",
            onAction = { onNavigate("notices") }
        )
        if (overview.recentNotices.isEmpty()) {
            Box(
                modifier = Modifier.fillMaxWidth().weight(1f),
                contentAlignment = Alignment.Center
            ) {
                AdminListEmptyState(
                    title = "No recent notices",
                    subtitle = "There are no notices to display yet."
                )
            }
        } else {
            DesktopAwareLazyColumn(
                modifier = Modifier.fillMaxWidth().weight(1f),
                contentPadding = PaddingValues(end = 22.dp)
            ) {
                overview.recentNotices.forEachIndexed { index, notice ->
                    item(key = "notice-$index") {
                        TeacherNoticeRow(
                            notice.title.orEmpty().ifBlank { "Untitled notice" },
                            dashboardDateLabel(notice.createdAt),
                            "megaphone",
                            HomePurpleSoft,
                            HomePurple
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun TeacherEventsCard(
    overview: TeacherDashboardOverviewResponse?,
    isLoading: Boolean,
    modifier: Modifier = Modifier,
    onNavigate: (String) -> Unit = {}
) {
    if (isLoading || overview == null) {
        TeacherDashboardCardShimmer(modifier)
        return
    }
    TeacherDashboardCard(modifier = modifier) {
        TeacherCardHeader(
            icon = "calendar",
            iconTint = HomePurple,
            iconBackground = HomePurpleSoft,
            title = "Upcoming Events",
            actionLabel = "View Events",
            onAction = { onNavigate("events-news") }
        )
        if (overview.upcomingEvents.isEmpty()) {
            Box(
                modifier = Modifier.fillMaxWidth().weight(1f),
                contentAlignment = Alignment.Center
            ) {
                AdminListEmptyState(
                    title = "No upcoming events",
                    subtitle = "There are no events to display yet."
                )
            }
        } else {
            DesktopAwareLazyColumn(
                modifier = Modifier.fillMaxWidth().weight(1f),
                contentPadding = PaddingValues(end = 22.dp)
            ) {
                overview.upcomingEvents.forEachIndexed { index, event ->
                    val dateParts = dashboardDateParts(event.eventDate)
                    item(key = "event-$index") {
                        TeacherEventRow(
                            dateParts.first,
                            dateParts.second,
                            event.title.orEmpty().ifBlank { "Untitled event" },
                            event.audience.orEmpty(),
                            "",
                            HomeBlueSoft,
                            HomeBlue
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun TeacherDashboardCardShimmer(modifier: Modifier = Modifier) {
    val transition = rememberInfiniteTransition(label = "teacher_dashboard_card_shimmer")
    val shimmerX by transition.animateFloat(
        initialValue = -320f,
        targetValue = 960f,
        animationSpec = infiniteRepeatable(tween(1200, easing = LinearEasing), RepeatMode.Restart),
        label = "teacher_dashboard_card_shimmer_x"
    )
    val shimmerBrush = Brush.linearGradient(
        colors = listOf(HomeBorder.copy(alpha = .45f), Color.White, HomeBorder.copy(alpha = .45f)),
        start = Offset(shimmerX, 0f),
        end = Offset(shimmerX + 260f, 0f)
    )
    TeacherDashboardCard(modifier = modifier) {
        Row(horizontalArrangement = Arrangement.spacedBy(14.dp), verticalAlignment = Alignment.CenterVertically) {
            Box(Modifier.size(54.dp).background(shimmerBrush, RoundedCornerShape(16.dp)))
            Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                Box(Modifier.width(150.dp).height(20.dp).background(shimmerBrush, RoundedCornerShape(8.dp)))
                Box(Modifier.width(110.dp).height(14.dp).background(shimmerBrush, RoundedCornerShape(8.dp)))
            }
        }
        Spacer(Modifier.height(18.dp))
        repeat(5) {
            Box(Modifier.fillMaxWidth().height(32.dp).padding(vertical = 6.dp).background(shimmerBrush, RoundedCornerShape(6.dp)))
        }
    }
}

private fun dashboardDateParts(value: String?): Pair<String, String> {
    val date = value.orEmpty().substringBefore('T').substringBefore(' ')
    val parts = date.split('-')
    if (parts.size < 3) return "—" to ""
    return parts[2].padStart(2, '0') to when (parts[1].toIntOrNull()) {
        1 -> "JAN"; 2 -> "FEB"; 3 -> "MAR"; 4 -> "APR"; 5 -> "MAY"; 6 -> "JUN"
        7 -> "JUL"; 8 -> "AUG"; 9 -> "SEP"; 10 -> "OCT"; 11 -> "NOV"; 12 -> "DEC"
        else -> ""
    }
}

private fun dashboardDateLabel(value: String?): String {
    val parts = dashboardDateParts(value)
    return listOf(parts.first, parts.second).filter { it.isNotBlank() && it != "—" }.joinToString(" ").ifBlank { "—" }
}

@Composable
private fun TeacherDashboardCard(
    modifier: Modifier = Modifier,
    content: @Composable ColumnScope.() -> Unit
) {
    DashboardSurface(modifier = modifier) {
        Column(
            modifier = Modifier.fillMaxSize().padding(horizontal = 16.dp, vertical = 14.dp),
            content = content
        )
    }
}

@Composable
private fun TeacherCardHeader(
    icon: String,
    iconTint: Color,
    iconBackground: Color,
    title: String,
    subtitle: String? = null,
    actionLabel: String? = null,
    onAction: (() -> Unit)? = null
) {
    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(14.dp)
    ) {
        Box(
            modifier = Modifier.size(54.dp).background(iconBackground, RoundedCornerShape(16.dp)),
            contentAlignment = Alignment.Center
        ) {
            Icon(painter = homeIconPainter(icon), contentDescription = null, tint = iconTint, modifier = Modifier.size(30.dp))
        }
        Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
            Text(title, style = MaterialTheme.typography.titleLarge, fontWeight = FontWeight.Bold, color = HomeTextPrimary)
            subtitle?.let { Text(it, style = MaterialTheme.typography.bodyMedium, color = HomeTextPrimary) }
        }
        actionLabel?.let { label -> Text(label, style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.Bold, color = HomeBlue, modifier = Modifier.clickable { onAction?.invoke() }) }
    }
    Spacer(Modifier.height(12.dp))
    HorizontalDivider(color = HomeBorder)
}

@Composable
private fun TeacherTableHeader(labels: List<String>) {
    Row(modifier = Modifier.fillMaxWidth().padding(start = 32.dp, end = 22.dp).padding(horizontal = 8.dp, vertical = 10.dp)) {
        labels.forEachIndexed { index, label ->
            Text(
                text = label,
                modifier = Modifier.weight(if (index == 0) 1f else 1f),
                style = MaterialTheme.typography.bodyMedium,
                fontWeight = FontWeight.Bold,
                color = HomeTextPrimary
            )
        }
    }
    HorizontalDivider(modifier = Modifier.padding(start = 32.dp, end = 22.dp), color = HomeBorder)
}

@Composable
private fun TeacherTableRow(
    values: List<String>,
    firstValueTint: Color,
    lastValueTint: Color = HomeTextPrimary
) {
    Row(modifier = Modifier.fillMaxWidth().padding(start = 32.dp).padding(horizontal = 8.dp, vertical = 11.dp)) {
        values.forEachIndexed { index, value ->
            Text(
                text = value,
                modifier = Modifier.weight(1f),
                style = MaterialTheme.typography.bodyMedium,
                fontWeight = if (index == 0 || index == values.lastIndex) FontWeight.SemiBold else FontWeight.Normal,
                color = when (index) {
                    0 -> firstValueTint
                    values.lastIndex -> lastValueTint
                    else -> HomeTextPrimary
                },
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
    }
    HorizontalDivider(modifier = Modifier.padding(start = 32.dp), color = HomeBorder)
}

@Composable
private fun TeacherNoticeRow(
    title: String,
    time: String,
    icon: String,
    iconBackground: Color,
    iconTint: Color
) {
    Row(
        modifier = Modifier.fillMaxWidth().padding(vertical = 10.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        Box(modifier = Modifier.size(34.dp).background(iconBackground, RoundedCornerShape(10.dp)), contentAlignment = Alignment.Center) {
            Icon(painter = homeIconPainter(icon), contentDescription = null, tint = iconTint, modifier = Modifier.size(20.dp))
        }
        Text(title, modifier = Modifier.weight(1f), style = MaterialTheme.typography.bodyMedium, color = HomeTextPrimary, maxLines = 1, overflow = TextOverflow.Ellipsis)
        Text(time, style = MaterialTheme.typography.bodySmall, color = HomeTextPrimary)
    }
    HorizontalDivider(color = HomeBorder)
}

@Composable
private fun TeacherEventRow(
    day: String,
    month: String,
    title: String,
    detail: String,
    trailing: String,
    dateBackground: Color,
    dateTint: Color
) {
    Row(
        modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(12.dp)
    ) {
        Column(modifier = Modifier.size(48.dp).background(dateBackground, RoundedCornerShape(10.dp)), horizontalAlignment = Alignment.CenterHorizontally, verticalArrangement = Arrangement.Center) {
            Text(day, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, color = dateTint)
            Text(month, style = MaterialTheme.typography.labelSmall, fontWeight = FontWeight.Bold, color = dateTint)
        }
        Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(2.dp)) {
            Text(title, style = MaterialTheme.typography.bodyMedium, fontWeight = FontWeight.Bold, color = HomeTextPrimary, maxLines = 1, overflow = TextOverflow.Ellipsis)
            Text(detail, style = MaterialTheme.typography.bodyMedium, color = HomeTextPrimary, maxLines = 1, overflow = TextOverflow.Ellipsis)
        }
        Text(trailing, style = MaterialTheme.typography.bodySmall, color = HomeTextPrimary)
    }
    HorizontalDivider(color = HomeBorder)
}

@Composable
private fun HomeHeader(
    state: HomeUiState,
    onEvent: (HomeUiEvent) -> Unit,
    onLogout: () -> Unit,
    onEditProfile: () -> Unit
) {
    val parent = state.roleCode == SchoolKeys.V_ROLE_PARENT
    val teacher = state.roleCode == SchoolKeys.V_ROLE_TEACHER
    val schoolAdmin = state.roleCode == SchoolKeys.V_ROLE_SCHOOL_ADMIN
    val superAdmin = state.roleCode == SchoolKeys.V_ROLE_APP_SUPER_ADMIN
    val reportsPage = (superAdmin && state.selectedNavId == "reports") ||
        ((teacher || schoolAdmin) && state.selectedNavId == "analytics-reports")
    val greetingName = if (parent) {
        state.userProfile.fullName.ifBlank { state.roleLabel }
    } else {
        state.userProfile.fullName.ifBlank { state.roleLabel }
    }
    val parentChildContext = LocalParentChildContext.current
    Row(
        modifier = Modifier.fillMaxWidth(),
        verticalAlignment = Alignment.Top
    ) {
        Column(
            modifier = Modifier.weight(1f),
            verticalArrangement = Arrangement.spacedBy(8.dp)
        ) {
            Text(
                text = if (reportsPage) "Reports & Analytics" else if (parent || teacher || schoolAdmin || superAdmin) "Hello, $greetingName" else "Good Morning, $greetingName",
                style = MaterialTheme.typography.headlineMedium,
                fontWeight = FontWeight.Bold,
                color = AppPageHeader
            )
            if (reportsPage) {
                Text(
                    text = if (superAdmin) "Review usage, adoption and activity across authorized school accounts." else "View attendance, academic performance and activity reports.",
                    style = MaterialTheme.typography.bodyMedium,
                    color = AppPageSubtitle
                )
            } else if (parent) {
                Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                    ParentChildHeaderSelector(
                        context = parentChildContext,
                        compact = false,
                        showAvatar = false,
                        showCurrentChildLabel = false
                    )
                    Text("|", color = HomeBorder)
                    Text(state.schoolLabel.ifBlank { "Greenfield High School" }, style = MaterialTheme.typography.bodyMedium, color = AppPageSubtitle, fontWeight = FontWeight.SemiBold)
                    Text("|", color = HomeBorder)
                    Text(state.activeAcademicYearLabel.ifBlank { "AY 2026-27" }, style = MaterialTheme.typography.bodyMedium, color = AppPageSubtitle, fontWeight = FontWeight.SemiBold)
                }
            } else if (teacher || schoolAdmin) {
                Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                    Text(state.schoolLabel.ifBlank { "Greenfield High School" }, style = MaterialTheme.typography.bodyMedium, color = AppPageSubtitle, fontWeight = FontWeight.SemiBold)
                    Text("|", color = HomeBorder)
                    Text(state.activeAcademicYearLabel.ifBlank { "AY 2026-27" }, style = MaterialTheme.typography.bodyMedium, color = AppPageSubtitle, fontWeight = FontWeight.SemiBold)
                }
            } else if (superAdmin) {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Text(
                        text = "iConnect.",
                        style = MaterialTheme.typography.bodyMedium,
                        color = AppBrandWordmarkDark,
                        fontWeight = FontWeight.SemiBold
                    )
                    Text(
                        text = "School",
                        style = MaterialTheme.typography.bodyMedium,
                        color = AppBrandWordmarkLight,
                        fontWeight = FontWeight.SemiBold
                    )
                    Text(
                        text = " Administration",
                        style = MaterialTheme.typography.bodyMedium,
                        color = AppPageSubtitle,
                        fontWeight = FontWeight.SemiBold
                    )
                }
            } else {
                Text(
                    text = "Here's what's happening with iConnect.School today.",
                    style = MaterialTheme.typography.bodyLarge,
                    color = AppPageSubtitle
                )
            }
        }
        ShellTopRightActions(
            roleLabel = state.roleLabel,
            roleSubtitle = state.roleSubtitle,
            initials = shellAvatarInitials(state.userProfile.fullName.ifBlank { state.roleLabel }),
            expanded = state.isAccountMenuExpanded,
            onExpandedChange = { expanded ->
                onEvent(if (expanded) HomeUiEvent.AccountMenuToggled else HomeUiEvent.AccountMenuDismissed)
            },
            onChangeRole = { onEvent(HomeUiEvent.RolePickerRequested) },
            onLogout = onLogout,
            onMyProfile = onEditProfile,
            profileName = state.userProfile.fullName,
            profileEmail = state.userProfile.email
        )
    }
}

@Composable
internal fun ProfileSummaryCard(
    state: HomeUiState,
    onEditProfile: () -> Unit
) {
    val profile = state.userProfile
    if (state.roleCode == SchoolKeys.V_ROLE_APP_SUPER_ADMIN && profile.isLoading) {
        ProfileCardShimmer()
        return
    }

    val displayName = profile.fullName.ifBlank { state.roleLabel }
    val email = resolvedProfileValue(profile.email, profile.isLoading)
    val mobileNumber = resolvedProfileValue(profile.mobileNumber, profile.isLoading)
    val employeeId = resolvedProfileValue(profile.employeeId, profile.isLoading)
    val lastLogin = resolvedProfileValue(profile.lastLoginLabel, profile.isLoading)
    DashboardSurface(
        modifier = Modifier.fillMaxWidth()
    ) {
        BoxWithConstraints(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 20.dp, vertical = 10.dp)
        ) {
            if (maxWidth >= 920.dp) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    AvatarChip(initials = shellAvatarInitials(displayName), modifier = Modifier.size(54.dp))
                    Spacer(modifier = Modifier.width(14.dp))
                    Column(
                        modifier = Modifier.weight(1f),
                        verticalArrangement = Arrangement.spacedBy(4.dp)
                    ) {
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            horizontalArrangement = Arrangement.spacedBy(8.dp)
                        ) {
                            Text(
                                text = displayName,
                                style = MaterialTheme.typography.titleLarge,
                                fontWeight = FontWeight.Bold,
                                color = HomeTextPrimary
                            )
                            RoleBadge(state.roleSubtitle)
                        }
                        Text(
                            text = profileContactLine(email, mobileNumber),
                            style = MaterialTheme.typography.bodyMedium,
                            color = HomeTextSecondary,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }
                    Spacer(modifier = Modifier.width(12.dp))
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        if (state.roleCode != SchoolKeys.V_ROLE_PARENT) {
                            ProfileMetaChip(title = "Employee ID", value = employeeId)
                        }
                        ProfileMetaChip(title = "Last Login", value = lastLogin)
                        OutlinedButton(
                            onClick = onEditProfile,
                            border = androidx.compose.foundation.BorderStroke(1.dp, HomeBlueSoft),
                            colors = ButtonDefaults.outlinedButtonColors(
                                containerColor = Color.White,
                                contentColor = HomeBlue
                            )
                        ) {
                            Icon(
                                painter = homeIconPainter("edit"),
                                contentDescription = null,
                                tint = HomeBlue,
                                modifier = Modifier.size(22.dp)
                            )
                            Spacer(modifier = Modifier.width(6.dp))
                            Text("Edit Profile", color = HomeBlue)
                        }
                    }
                }
            } else {
                Column(
                    modifier = Modifier.fillMaxWidth(),
                    verticalArrangement = Arrangement.spacedBy(10.dp)
                ) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(14.dp)
                    ) {
                        AvatarChip(initials = shellAvatarInitials(displayName), modifier = Modifier.size(56.dp))
                        Column(
                            modifier = Modifier.weight(1f),
                            verticalArrangement = Arrangement.spacedBy(4.dp)
                        ) {
                            Row(
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.spacedBy(8.dp)
                            ) {
                                Text(
                                    text = displayName,
                                    style = MaterialTheme.typography.titleLarge,
                                    fontWeight = FontWeight.Bold,
                                    color = HomeTextPrimary
                                )
                                RoleBadge(state.roleSubtitle)
                            }
                            Text(
                                text = email,
                                style = MaterialTheme.typography.bodyMedium,
                                color = HomeTextSecondary,
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    }
                    Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
                        if (state.roleCode != SchoolKeys.V_ROLE_PARENT) {
                            ProfileMetaChip(title = "Employee ID", value = employeeId)
                        }
                        ProfileMetaChip(title = "Last Login", value = lastLogin)
                    }
                    OutlinedButton(
                        onClick = onEditProfile,
                        modifier = Modifier.fillMaxWidth(),
                        border = androidx.compose.foundation.BorderStroke(1.dp, HomeBlueSoft),
                        colors = ButtonDefaults.outlinedButtonColors(
                            containerColor = Color.White,
                            contentColor = HomeBlue
                        )
                    ) {
                        Icon(
                            painter = homeIconPainter("edit"),
                            contentDescription = null,
                            tint = HomeBlue,
                            modifier = Modifier.size(20.dp)
                        )
                        Spacer(modifier = Modifier.width(6.dp))
                        Text("Edit Profile", color = HomeBlue)
                    }
                }
            }
        }
    }
}

@Composable
internal fun ProfileCardShimmer() {
    val transition = rememberInfiniteTransition(label = "profile_card_shimmer")
    val shimmerX by transition.animateFloat(
        initialValue = -520f,
        targetValue = 1480f,
        animationSpec = infiniteRepeatable(
            animation = tween(durationMillis = 1200, easing = LinearEasing),
            repeatMode = RepeatMode.Restart
        ),
        label = "profile_card_shimmer_x"
    )
    val shimmerBrush = Brush.linearGradient(
        colors = listOf(
            Color(0xFFE4EAF7),
            Color(0xFFF9FBFF),
            Color(0xFFE4EAF7)
        ),
        start = Offset(shimmerX, shimmerX),
        end = Offset(shimmerX + 240f, shimmerX + 240f)
    )

    DashboardSurface(modifier = Modifier.fillMaxWidth()) {
        BoxWithConstraints(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 20.dp, vertical = 10.dp)
        ) {
            if (maxWidth >= 920.dp) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Box(
                        modifier = Modifier
                            .size(54.dp)
                            .clip(CircleShape)
                            .background(shimmerBrush)
                    )
                    Spacer(modifier = Modifier.width(14.dp))
                    Column(
                        modifier = Modifier.weight(1f),
                        verticalArrangement = Arrangement.spacedBy(8.dp)
                    ) {
                        Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                            Box(
                                modifier = Modifier
                                    .width(190.dp)
                                    .height(24.dp)
                                    .clip(RoundedCornerShape(8.dp))
                                    .background(shimmerBrush)
                            )
                            Box(
                                modifier = Modifier
                                    .width(160.dp)
                                    .height(30.dp)
                                    .clip(RoundedCornerShape(16.dp))
                                    .background(shimmerBrush)
                            )
                        }
                        Box(
                            modifier = Modifier
                                .width(330.dp)
                                .height(18.dp)
                                .clip(RoundedCornerShape(8.dp))
                                .background(shimmerBrush)
                        )
                    }
                    Spacer(modifier = Modifier.width(12.dp))
                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                        repeat(2) { index ->
                            Box(
                                modifier = Modifier
                                    .width(if (index == 0) 132.dp else 172.dp)
                                    .height(56.dp)
                                    .clip(RoundedCornerShape(14.dp))
                                    .background(shimmerBrush)
                            )
                        }
                        Box(
                            modifier = Modifier
                                .width(180.dp)
                                .height(56.dp)
                                .clip(RoundedCornerShape(999.dp))
                                .background(shimmerBrush)
                        )
                    }
                }
            } else {
                Column(
                    modifier = Modifier.fillMaxWidth(),
                    verticalArrangement = Arrangement.spacedBy(10.dp)
                ) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        horizontalArrangement = Arrangement.spacedBy(14.dp)
                    ) {
                        Box(
                            modifier = Modifier
                                .size(56.dp)
                                .clip(CircleShape)
                                .background(shimmerBrush)
                        )
                        Column(verticalArrangement = Arrangement.spacedBy(8.dp)) {
                            Box(
                                modifier = Modifier
                                    .width(180.dp)
                                    .height(24.dp)
                                    .clip(RoundedCornerShape(8.dp))
                                    .background(shimmerBrush)
                            )
                            Box(
                                modifier = Modifier
                                    .width(220.dp)
                                    .height(18.dp)
                                    .clip(RoundedCornerShape(8.dp))
                                    .background(shimmerBrush)
                            )
                        }
                    }
                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                        Box(
                            modifier = Modifier
                                .weight(1f)
                                .height(48.dp)
                                .clip(RoundedCornerShape(14.dp))
                                .background(shimmerBrush)
                        )
                        Box(
                            modifier = Modifier
                                .weight(1f)
                                .height(48.dp)
                                .clip(RoundedCornerShape(14.dp))
                                .background(shimmerBrush)
                        )
                    }
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .height(48.dp)
                            .clip(RoundedCornerShape(999.dp))
                            .background(shimmerBrush)
                    )
                }
            }
        }
    }
}

private fun resolvedProfileValue(value: String, isLoading: Boolean): String {
    return when {
        value.isNotBlank() -> value
        isLoading -> "Loading..."
        else -> "—"
    }
}

private fun profileContactLine(email: String, mobileNumber: String): String {
    val parts = listOf(email, mobileNumber).filter { it.isNotBlank() && it != "—" && it != "Loading..." }
    return when {
        parts.isNotEmpty() -> parts.joinToString("  •  ")
        email == "Loading..." || mobileNumber == "Loading..." -> "Loading..."
        else -> "—"
    }
}

@Composable
private fun ProfileMetaChip(
    title: String,
    value: String
) {
    Column(
        modifier = Modifier
            .background(HomeBlueSoft.copy(alpha = 0.42f), RoundedCornerShape(14.dp))
            .padding(horizontal = 10.dp, vertical = 6.dp),
        verticalArrangement = Arrangement.spacedBy(2.dp)
    ) {
        Text(
            text = title,
            style = MaterialTheme.typography.labelSmall,
            color = HomeTextSecondary
        )
        Text(
            text = value,
            style = MaterialTheme.typography.bodyMedium,
            fontWeight = FontWeight.Bold,
            color = HomeTextPrimary,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

@Composable
private fun MetricGrid(
    metrics: List<MetricCardData>,
    columns: Int
) {
    val cols = columns.coerceAtLeast(1)
    Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
        metrics.chunked(cols).forEachIndexed { row, rowItems ->
            // Per-row equal height: tallest card in the row sets height; shorter cards stretch.
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(IntrinsicSize.Max),
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                rowItems.forEachIndexed { col, metric ->
                    val tone = AdminSummaryMetrics.gridTone(row * cols + col, cols)
                    MetricCard(
                        metric = metric.copy(accent = tone.accent, accentSoft = tone.soft),
                        modifier = Modifier
                            .weight(1f)
                            .fillMaxHeight()
                    )
                }
                repeat(cols - rowItems.size) {
                    Spacer(modifier = Modifier.weight(1f))
                }
            }
        }
    }
}

@Composable
private fun MetricGridShimmer(
    columns: Int,
    itemCount: Int
) {
    val cols = columns.coerceAtLeast(1)
    Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
        List(itemCount) { it }.chunked(cols).forEach { rowItems ->
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(IntrinsicSize.Max),
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                rowItems.forEach { _ ->
                    MetricCardShimmer(
                        modifier = Modifier
                            .weight(1f)
                            .fillMaxHeight()
                    )
                }
                repeat(cols - rowItems.size) {
                    Spacer(modifier = Modifier.weight(1f))
                }
            }
        }
    }
}

@Composable
private fun MetricCardShimmer(
    modifier: Modifier = Modifier
) {
    val transition = rememberInfiniteTransition(label = "metric_card_shimmer")
    val shimmerX by transition.animateFloat(
        initialValue = -400f,
        targetValue = 1400f,
        animationSpec = infiniteRepeatable(
            animation = tween(durationMillis = 1200),
            repeatMode = RepeatMode.Restart
        ),
        label = "metric_card_shimmer_x"
    )
    val shimmerBrush = Brush.linearGradient(
        colors = listOf(
            Color(0xFFE4EAF7),
            Color(0xFFF9FBFF),
            Color(0xFFE4EAF7)
        ),
        start = Offset(shimmerX, shimmerX),
        end = Offset(shimmerX + 240f, shimmerX + 240f)
    )

    DashboardSurface(
        modifier = modifier.heightIn(min = MetricCardMinHeight)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .fillMaxHeight()
                .padding(12.dp),
            horizontalArrangement = Arrangement.spacedBy(10.dp),
            verticalAlignment = Alignment.Top
        ) {
            Box(
                modifier = Modifier
                    .size(48.dp)
                    .clip(RoundedCornerShape(12.dp))
                    .background(shimmerBrush)
            )
            Column(
                verticalArrangement = Arrangement.spacedBy(4.dp)
            ) {
                Box(
                    modifier = Modifier
                        .width(96.dp)
                        .height(12.dp)
                        .clip(RoundedCornerShape(6.dp))
                        .background(shimmerBrush)
                )
                Box(
                    modifier = Modifier
                        .width(64.dp)
                        .height(22.dp)
                        .clip(RoundedCornerShape(6.dp))
                        .background(shimmerBrush)
                )
                Box(
                    modifier = Modifier
                        .width(132.dp)
                        .height(11.dp)
                        .clip(RoundedCornerShape(6.dp))
                        .background(shimmerBrush)
                )
                Column(verticalArrangement = Arrangement.spacedBy(3.dp)) {
                    repeat(2) {
                        Box(
                            modifier = Modifier
                                .width(120.dp)
                                .height(10.dp)
                                .clip(RoundedCornerShape(6.dp))
                                .background(shimmerBrush)
                        )
                    }
                }
            }
        }
    }
}

private fun expectedDashboardMetricCount(roleCode: String): Int {
    return if (roleCode == SchoolKeys.V_ROLE_APP_SUPER_ADMIN) 8 else 4
}

private val MetricCardMinHeight = 132.dp

@Composable
private fun MetricCard(
    metric: MetricCardData,
    modifier: Modifier = Modifier
) {
    Card(
        modifier = modifier.heightIn(min = MetricCardMinHeight),
        shape = RoundedCornerShape(8.dp),
        colors = CardDefaults.cardColors(containerColor = metric.accentSoft),
        border = BorderStroke(1.dp, AdminSummaryMetrics.CardBorder),
        elevation = CardDefaults.cardElevation(defaultElevation = 0.dp)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .fillMaxHeight()
                .padding(14.dp),
            horizontalArrangement = Arrangement.spacedBy(12.dp),
            verticalAlignment = Alignment.Top
        ) {
            Box(
                modifier = Modifier
                    .size(52.dp)
                    .background(Color.White.copy(alpha = 0.72f), RoundedCornerShape(12.dp)),
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    painter = homeIconPainter(metric.icon),
                    contentDescription = null,
                    tint = metric.accent,
                    modifier = Modifier.size(26.dp)
                )
            }
            Column(
                modifier = Modifier.weight(1f),
                verticalArrangement = Arrangement.spacedBy(4.dp)
            ) {
                Text(
                    text = metric.title,
                    style = MaterialTheme.typography.titleSmall,
                    fontWeight = FontWeight.Bold,
                    color = HomeTextPrimary,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = metric.value,
                    style = MaterialTheme.typography.headlineSmall,
                    fontWeight = FontWeight.ExtraBold,
                    color = HomeTextPrimary,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = metric.subtitle,
                    style = MaterialTheme.typography.bodyMedium,
                    color = HomeTextSecondary,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                when (val footer = metric.footer) {
                    is MetricFooter.Bullets -> {
                        if (footer.entries.isNotEmpty()) {
                            Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
                                footer.entries.forEach { (label, color) ->
                                    SmallStatDot(color = color, label = label)
                                }
                            }
                        }
                    }
                    is MetricFooter.BulletGrid -> {
                        MetricBulletGrid(
                            entries = footer.entries,
                            columns = footer.columns.coerceAtLeast(1)
                        )
                    }
                    is MetricFooter.Trend -> {
                        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                            Text(
                                text = "↑ ${footer.value}",
                                style = MaterialTheme.typography.bodyMedium,
                                fontWeight = FontWeight.Bold,
                                color = footer.color
                            )
                            Text(
                                text = footer.label,
                                style = MaterialTheme.typography.bodyMedium,
                                color = HomeTextSecondary
                            )
                        }
                    }
                    is MetricFooter.Warning -> {
                        Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(6.dp)) {
                            Text(
                                text = footer.value,
                                style = MaterialTheme.typography.bodyMedium,
                                fontWeight = FontWeight.Bold,
                                color = footer.color
                            )
                            Text(
                                text = footer.label,
                                style = MaterialTheme.typography.bodyMedium,
                                color = HomeTextPrimary
                            )
                        }
                    }
                    is MetricFooter.Caption -> {
                        if (footer.text.isNotBlank()) {
                            Text(
                                text = footer.text,
                                style = MaterialTheme.typography.bodyMedium,
                                color = footer.color
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun MetricBulletGrid(
    entries: List<Pair<String, Color>>,
    columns: Int
) {
    if (entries.isEmpty()) return
    Column(verticalArrangement = Arrangement.spacedBy(4.dp)) {
        entries.chunked(columns).forEach { rowEntries ->
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(10.dp)
            ) {
                rowEntries.forEach { (label, color) ->
                    Box(modifier = Modifier.weight(1f)) {
                        SmallStatDot(color = color, label = label)
                    }
                }
                repeat(columns - rowEntries.size) {
                    Spacer(modifier = Modifier.weight(1f))
                }
            }
        }
    }
}

@Composable
private fun ActivityAndHealthSection(
    recentActivities: List<ActivityEntry>,
    healthEntries: List<HealthEntry>,
    isLoading: Boolean,
    hasHealthData: Boolean
) {
    BoxWithConstraints(modifier = Modifier.fillMaxWidth()) {
        val twoColumnLayout = maxWidth >= 900.dp
        val panelHeight = 420.dp
        if (twoColumnLayout) {
            Row(horizontalArrangement = Arrangement.spacedBy(16.dp), modifier = Modifier.fillMaxWidth()) {
                RecentSystemActivityPanel(
                    activities = recentActivities,
                    isLoading = isLoading,
                    modifier = Modifier
                        .weight(1f)
                        .height(panelHeight)
                )
                HealthPanel(
                    healthEntries = healthEntries,
                    isLoading = isLoading && !hasHealthData,
                    modifier = Modifier
                        .weight(1f)
                        .height(panelHeight)
                )
            }
        } else {
            Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                RecentSystemActivityPanel(
                    activities = recentActivities,
                    isLoading = isLoading,
                    modifier = Modifier
                        .fillMaxWidth()
                        .heightIn(min = 500.dp)
                )
                HealthPanel(
                    healthEntries = healthEntries,
                    isLoading = isLoading && !hasHealthData,
                    modifier = Modifier
                        .fillMaxWidth()
                        .heightIn(min = panelHeight)
                )
            }
        }
    }
}

@Composable
private fun RecentSystemActivityPanel(
    activities: List<ActivityEntry>,
    isLoading: Boolean,
    modifier: Modifier = Modifier
) {
    var showActivityInfo by remember { mutableStateOf(false) }
    DashboardSurface(modifier = modifier) {
        Column(modifier = Modifier.fillMaxSize()) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 20.dp, vertical = 14.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    text = "Recent System Activity",
                    style = MaterialTheme.typography.titleMedium,
                    fontWeight = FontWeight.Bold,
                    color = HomeTextPrimary,
                    modifier = Modifier.weight(1f)
                )
                Box {
                    Icon(
                        imageVector = Icons.Default.Info,
                        contentDescription = "Activity feed info",
                        tint = HomeBlue,
                        modifier = Modifier
                            .size(18.dp)
                            .clickable { showActivityInfo = !showActivityInfo }
                    )
                    AppDropdownMenu(
                        expanded = showActivityInfo,
                        onDismissRequest = { showActivityInfo = false }
                    ) {
                        Text(
                            text = "School Setup & Platform Operation Activity in the last 3 days",
                            style = MaterialTheme.typography.bodySmall,
                            color = HomeTextPrimary,
                            modifier = Modifier
                                .widthIn(max = 280.dp)
                                .padding(horizontal = 12.dp, vertical = 8.dp)
                        )
                    }
                }
            }
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .weight(1f)
                    .verticalScroll(rememberScrollState())
            ) {
                if (isLoading) {
                    ActivityPanelShimmer()
                } else if (activities.isEmpty()) {
                    EmptyPanelState(
                        title = "No recent activity",
                        subtitle = "School setup and platform activity from the last 3 days will appear here."
                    )
                } else {
                    activities.forEachIndexed { index, entry ->
                        if (index > 0) {
                            androidx.compose.material3.HorizontalDivider(color = HomeBorder)
                        }
                        ActivityRow(entry = entry)
                    }
                }
            }
        }
    }
}

@Composable
private fun ActivityRow(entry: ActivityEntry) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 18.dp, vertical = 14.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier
                .size(32.dp)
                .background(entry.iconBg, RoundedCornerShape(8.dp)),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = homeIconPainter(entry.icon),
                contentDescription = null,
                tint = entry.iconTint,
                modifier = Modifier.size(18.dp)
            )
        }
        Spacer(modifier = Modifier.width(14.dp))
        Text(
            text = entry.title,
            style = MaterialTheme.typography.bodyMedium,
            fontWeight = FontWeight.Medium,
            color = HomeTextPrimary,
            maxLines = 2,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier.weight(1.4f)
        )
        Text(
            text = entry.actorLogin?.takeIf { it.isNotBlank() } ?: "—",
            style = MaterialTheme.typography.bodyMedium,
            fontWeight = FontWeight.Medium,
            color = HomeTextSecondary,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
            modifier = Modifier
                .weight(1f)
                .padding(horizontal = 10.dp)
        )
        Text(
            text = entry.time,
            style = MaterialTheme.typography.bodySmall,
            color = HomeTextSecondary,
            maxLines = 1,
            modifier = Modifier.widthIn(min = 108.dp)
        )
    }
}

@Composable
private fun ActivityPanelShimmer() {
    val transition = rememberInfiniteTransition(label = "activity_panel_shimmer")
    val shimmerX by transition.animateFloat(
        initialValue = -400f,
        targetValue = 1400f,
        animationSpec = infiniteRepeatable(
            animation = tween(durationMillis = 1200),
            repeatMode = RepeatMode.Restart
        ),
        label = "activity_panel_shimmer_x"
    )
    val shimmerBrush = Brush.linearGradient(
        colors = listOf(
            Color(0xFFE6EBF5),
            Color(0xFFF7F9FD),
            Color(0xFFE6EBF5)
        ),
        start = Offset(shimmerX, shimmerX),
        end = Offset(shimmerX + 240f, shimmerX + 240f)
    )

    Column(modifier = Modifier.fillMaxWidth()) {
        repeat(4) { index ->
            if (index > 0) {
                androidx.compose.material3.HorizontalDivider(color = HomeBorder)
            }
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 18.dp, vertical = 12.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Box(
                    modifier = Modifier
                        .size(32.dp)
                        .clip(RoundedCornerShape(8.dp))
                        .background(shimmerBrush)
                )
                Spacer(modifier = Modifier.width(14.dp))
                Column(
                    modifier = Modifier.weight(1f),
                    verticalArrangement = Arrangement.spacedBy(5.dp)
                ) {
                    Box(
                        modifier = Modifier
                            .width(156.dp)
                            .height(12.dp)
                            .clip(RoundedCornerShape(8.dp))
                            .background(shimmerBrush)
                    )
                    Box(
                        modifier = Modifier
                            .width(108.dp)
                            .height(9.dp)
                            .clip(RoundedCornerShape(8.dp))
                            .background(shimmerBrush)
                    )
                }
                Spacer(modifier = Modifier.width(12.dp))
                Box(
                    modifier = Modifier
                        .width(36.dp)
                        .height(18.dp)
                        .clip(RoundedCornerShape(8.dp))
                        .background(shimmerBrush)
                )
                Spacer(modifier = Modifier.width(12.dp))
                Box(
                    modifier = Modifier
                        .width(52.dp)
                        .height(9.dp)
                        .clip(RoundedCornerShape(8.dp))
                        .background(shimmerBrush)
                )
            }
        }
    }
}

@Composable
private fun HealthPanel(
    healthEntries: List<HealthEntry>,
    isLoading: Boolean,
    modifier: Modifier = Modifier
) {
    DashboardSurface(modifier = modifier) {
        Column(modifier = Modifier.fillMaxSize()) {
            PanelHeader(title = "System Health", actionLabel = null)
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(360.dp)
            ) {
                if (isLoading) {
                    HealthPanelShimmer()
                } else if (healthEntries.isEmpty()) {
                    EmptyPanelState(
                        title = "System health unavailable",
                        subtitle = "Health checks could not be loaded at the moment."
                    )
                } else {
                    healthEntries.forEachIndexed { index, entry ->
                        if (index > 0) {
                            androidx.compose.material3.HorizontalDivider(color = HomeBorder)
                        }
                        HealthRow(
                            entry = entry,
                            modifier = Modifier
                        )
                    }
                }
            }
        }
    }
}

@Composable
private fun HealthPanelShimmer() {
    val transition = rememberInfiniteTransition(label = "health_panel_shimmer")
    val shimmerX by transition.animateFloat(
        initialValue = -400f,
        targetValue = 1400f,
        animationSpec = infiniteRepeatable(
            animation = tween(durationMillis = 1200),
            repeatMode = RepeatMode.Restart
        ),
        label = "health_panel_shimmer_x"
    )
    val shimmerBrush = Brush.linearGradient(
        colors = listOf(
            Color(0xFFE6EBF5),
            Color(0xFFF7F9FD),
            Color(0xFFE6EBF5)
        ),
        start = Offset(shimmerX, shimmerX),
        end = Offset(shimmerX + 240f, shimmerX + 240f)
    )

    Column(modifier = Modifier.fillMaxWidth()) {
        repeat(5) { index ->
            if (index > 0) {
                androidx.compose.material3.HorizontalDivider(color = HomeBorder)
            }
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 18.dp, vertical = 12.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Box(
                    modifier = Modifier
                        .size(22.dp)
                        .clip(CircleShape)
                        .background(shimmerBrush)
                )
                Spacer(modifier = Modifier.width(14.dp))
                Column(
                    modifier = Modifier.weight(1f),
                    verticalArrangement = Arrangement.spacedBy(5.dp)
                ) {
                    Box(
                        modifier = Modifier
                            .width(132.dp)
                            .height(12.dp)
                            .clip(RoundedCornerShape(8.dp))
                            .background(shimmerBrush)
                    )
                    Box(
                        modifier = Modifier
                            .width(94.dp)
                            .height(9.dp)
                            .clip(RoundedCornerShape(8.dp))
                            .background(shimmerBrush)
                    )
                }
                Spacer(modifier = Modifier.width(12.dp))
                Box(
                    modifier = Modifier
                        .width(82.dp)
                        .height(11.dp)
                        .clip(RoundedCornerShape(8.dp))
                        .background(shimmerBrush)
                )
            }
        }
    }
}

@Composable
private fun HealthRow(
    entry: HealthEntry,
    modifier: Modifier = Modifier
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .height(60.dp)
            .padding(horizontal = 18.dp, vertical = 14.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(
            painter = homeIconPainter(entry.icon),
            contentDescription = null,
            tint = entry.iconTint,
            modifier = Modifier.size(22.dp)
        )
        Spacer(modifier = Modifier.width(14.dp))
        Text(
            text = entry.title,
            modifier = Modifier.weight(1f),
            style = MaterialTheme.typography.bodyMedium,
            fontWeight = FontWeight.Medium,
            color = HomeTextPrimary,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        Text(
            text = entry.value,
            modifier = Modifier.widthIn(max = 180.dp),
            style = MaterialTheme.typography.bodyMedium,
            fontWeight = FontWeight.Bold,
            color = HomeGreen,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
        Spacer(modifier = Modifier.width(10.dp))
        Box(
            modifier = Modifier
                .size(8.dp)
                .background(HomeGreen, CircleShape)
        )
    }
}

@Composable
private fun PanelHeader(
    title: String,
    actionLabel: String?
) {
    AdminListPanelHeader(
        title = title,
        actionLabel = actionLabel,
        horizontalPadding = 20.dp,
        verticalPadding = 14.dp,
        titleColor = AppPageHeader,
        actionColor = HomeBlue
    )
}

@Composable
private fun EmptyPanelState(
    title: String,
    subtitle: String
) {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = 20.dp, vertical = 30.dp),
        contentAlignment = Alignment.Center
    ) {
        AdminListEmptyState(
            title = title,
            subtitle = subtitle
        )
    }
}
